// import { useEffect, useState } from "react";
// import "./registrationform.css";
// import { FaCloudUploadAlt } from "react-icons/fa";
// import { FaCloud } from "react-icons/fa";
// import { IoMdSend } from "react-icons/io";
// import axios from "axios";
// import { states, cities, pincodes } from "./locationdata.js";

// const RegistrationForm = () => {
//   // const currentUrl = window.location.href;
//   // const location = useLocation()

//   // const baseUrl = 'https://tupperware-app.vercel.app/';

//   // if (currentUrl !== baseUrl) {
//   //     window.location.href = baseUrl;
//   // }

//   // const [selectedFiles, setSelectedFiles] = useState({
//   //     photo: "",
//   //     addressProofFront: "",
//   //     addressProofBack: "",
//   // });

//   const [photo, setPhoto] = useState("");
//   const [addressProofFront, setAddressProofFront] = useState("");
//   const [addressProofBack, setAddressProofBack] = useState("");
//   const [photoFileURL, setPhotoFileURL] = useState("");
//   // console.log("photoFileURL ============>>>>>>>>>>>", photoFileURL)
//   const [addressProofFrontFileURL, setAddressProofFrontFileURL] = useState("");
//   const [addressProofBackFileURL, setAddressProofBackFileURL] = useState("");

//   const [formData, setFormData] = useState({
//     consultantId: "",
//     interest: "",
//     currentLocationState: "",
//     currentLocationCity: "",
//     currentLocationPincode: "",
//     currentLocationPincodeCode: "",
//     currentAddress: "",
//     sameAddress: false,
//     permanentLocationState: null,
//     permanentLocationCity: null,
//     permanentLocationPincode: "",
//     permanentLocationPincodeCode: "",
//     permanentAddress: "",
//     name: "",
//     dob: "",
//     mobile: "",
//     email: "",
//     addressProof: "",
//     documentNumber: "",
//     photo: photoFileURL,
//     addressProofFront: addressProofFront,
//     addressProofBack: addressProofBack,
//     termsAccepted: false,
//     consultantAgreementAccepted: false,
//     otp: null,
//   });
//   console.log("formData", formData);

//   useEffect(() => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       photo: photoFileURL,
//       addressProofFront: addressProofFrontFileURL,
//       addressProofBack: addressProofBackFileURL,
//     }));
//   }, [photoFileURL, addressProofFrontFileURL, addressProofBackFileURL]);

//   useEffect(() => {
//     handleOpportunityPopup();
//   }, []);

//   // const handleChange = (e) => {
//   //     const { name, value, type, checked } = e.target;
//   //     setFormData((prevData) => ({
//   //         ...prevData,
//   //         [name]: type === 'checkbox' ? checked : value,
//   //     }));
//   //     setErrorMessage("");
//   //     setMessage("");
//   // };

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;

//     setFormData((prevData) => {
//       if (name === "currentAddress") {
//         return {
//           ...prevData,
//           [name]: value, // Update the current address field
//           sameAddress: false, // Automatically uncheck the checkbox
//           permanentLocationState: null, // Reset permanent address fields
//           permanentLocationCity: null,
//           permanentLocationPincode: "",
//           permanentAddress: "",
//         };
//       }

//       if (name === "sameAddress") {
//         return {
//           ...prevData,
//           [name]: checked,
//           ...(checked && {
//             // Copy current address fields if 'sameAddress' is checked
//             permanentLocationState: prevData.currentLocationState,
//             permanentLocationCity: prevData.currentLocationCity,
//             permanentLocationPincode: prevData.currentLocationPincode,
//             permanentLocationPincodeCode: prevData.currentLocationPincodeCode,
//             permanentAddress: prevData.currentAddress,
//           }),
//           ...(!checked && {
//             // Reset permanent address fields if 'sameAddress' is unchecked
//             permanentLocationState: null,
//             permanentLocationCity: null,
//             permanentLocationPincode: "",
//             permanentLocationPincodeCode: "",
//             permanentAddress: "",
//           }),
//         };
//       }

//       // For other form fields
//       return {
//         ...prevData,
//         [name]: type === "checkbox" ? checked : value,
//       };
//     });

//     setErrorMessage("");
//     setMessage("");
//   };

//   const handleSubmit = () => {
//     // console.log('Form Data:', formData);
//     setMessage("");
//     setErrorMessage("");
//     registerUser();
//   };

//   // const [selectedFiles, setSelectedFiles] = useState({
//   //     photo: "",
//   //     addressProofFront: "",
//   //     addressProofBack: "",
//   // });
//   //   const [isReferred, setIsReferred] = useState(false);
//   const [message, setMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   const [consultantId, setConsultantId] = useState("");
//   const [isConsultantIdFocused, setIsConsultantIdFocused] = useState(false);

//   // const handlePhotoFileChange = (event) => {
//   //     const { id, files } = event.target;
//   //     setSelectedFiles({
//   //         ...selectedFiles,
//   //         [id]: files[0]?.name || "",
//   //     });
//   // };
//   // const handleAddressProofFrontFileChange = (event) => {
//   //     const { id, files } = event.target;
//   //     setSelectedFiles({
//   //         ...selectedFiles,
//   //         [id]: files[0]?.name || "",
//   //     });
//   // };
//   // const handleAddressProofBackFileChange = (event) => {
//   //     const { id, files } = event.target;
//   //     setSelectedFiles({
//   //         ...selectedFiles,
//   //         [id]: files[0]?.name || "",
//   //     });
//   // };
//   useEffect(() => {
//     if (consultantId.length >= 1) {
//       setIsConsent(true);
//     } else {
//       setIsConsent(false);
//     }
//   }, [consultantId]);

//   // const uploadPhoto = async (file) => {
//   //     const formData = new FormData();
//   //     formData.append('image', file);

//   //     try {
//   //         const response = await axios.post(
//   //             // 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/media/upload/single',
//   //             'https://tupperware-service.cloud/services/media/upload/single',
//   //             formData,
//   //             {
//   //                 headers: {
//   //                     'Content-Type': 'multipart/form-data',
//   //                 },
//   //             }
//   //         );

//   //         if (response.status === 200) {
//   //             const uploadedPhotoLocation = response?.data?.Response?.location;
//   //             // console.log('File uploaded successfully :::::::::::::::::::::', uploadedPhotoLocation);
//   //             setPhotoFileURL(uploadedPhotoLocation);
//   //             // formData.photo = uploadedPhotoLocation;
//   //         } else {
//   //             console.log('Unexpected response status:', response.status);
//   //         }
//   //     } catch (error) {
//   //         console.error('Error uploading file:', error);
//   //     }
//   // };
//   // const uploadAddressProofFront = async (file) => {
//   //     const formData = new FormData();
//   //     formData.append('image', file);

//   //     try {
//   //         const response = await axios.post(
//   //             // 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/media/upload/single',
//   //             'https://tupperware-service.cloud/services/media/upload/single',
//   //             formData,
//   //             {
//   //                 headers: {
//   //                     'Content-Type': 'multipart/form-data',
//   //                 },
//   //             }
//   //         );

//   //         if (response.status === 200) {
//   //             const uploadAddressProofFrontLocation = response?.data?.Response?.location;
//   //             // console.log('File uploaded successfully :::::::::::::::::::::', uploadAddressProofFrontLocation);
//   //             setAddressProofFrontFileURL(uploadAddressProofFrontLocation);
//   //             // formData.photo = uploadedPhotoLocation;
//   //         } else {
//   //             console.log('Unexpected response status:', response.status);
//   //         }
//   //     } catch (error) {
//   //         console.error('Error uploading file:', error);
//   //     }
//   // };
//   // const uploadAddressProofBack = async (file) => {
//   //     const formData = new FormData();
//   //     formData.append('image', file);

//   //     try {
//   //         const response = await axios.post(
//   //             // 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/media/upload/single',
//   //             'https://tupperware-service.cloud/services/media/upload/single',
//   //             formData,
//   //             {
//   //                 headers: {
//   //                     'Content-Type': 'multipart/form-data',
//   //                 },
//   //             }
//   //         );

//   //         if (response.status === 200) {
//   //             const uploadAddressProofBackLocation = response?.data?.Response?.location;
//   //             // console.log('File uploaded successfully :::::::::::::::::::::', uploadAddressProofBackLocation);
//   //             setAddressProofBackFileURL(uploadAddressProofBackLocation);
//   //             // formData.photo = uploadedPhotoLocation;
//   //         } else {
//   //             console.log('Unexpected response status:', response.status);
//   //         }
//   //     } catch (error) {
//   //         console.error('Error uploading file:', error);
//   //     }
//   // };

//   // const handlePhotoFileChange = (event) => {
//   //     const { files } = event.target;
//   //     uploadPhoto(files[0]);
//   //     console.log("files[0]",files[0]);
//   //     setPhoto(files[0]?.name || "");
//   // };

//   // const handlePhotoFileChange = async (event) => {
//   //     const { files } = event.target;
//   //     if (files.length > 0) {
//   //         const file = files[0];
//   //         await uploadPhoto(file);
//   //         setPhoto(file.name);
//   //     } else {
//   //         setPhoto("");
//   //     }
//   // };
//   const [uploadPhotoLoading, setUploadPhotoLoading] = useState(false);
//   const handlePhotoFileChange = async (event) => {
//     setErrorMessage("");
//     const file = event.target.files[0];

//     if (file) {
//       //   setPhoto(file.name); // Display file name
//       const formData = new FormData();
//       formData.append("file", file);
//       setUploadPhotoLoading(true);

//       try {
//         const response = await axios.post(
//           "https://tupperware-service.cloud/services/media/uploads",
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           },
//         );

//         if (response?.data?.success === true) {
//           // setPhoto(file.name); // Display file name
//           setUploadPhotoLoading(false);
//           setPhoto(response?.data?.filename); // Display file name
//           setPhotoFileURL(response?.data?.filename);
//           // console.log("File uploaded successfully:", response.data);
//         } else {
//           setUploadPhotoLoading(false);
//           setErrorMessage(
//             "There is something wrong with the file you uploaded, Please try again",
//           );
//         }
//         // Optionally, handle success (e.g., show a success message or update UI)
//       } catch (error) {
//         console.error("Error uploading file:", error);
//         setUploadPhotoLoading(false);
//         setErrorMessage(
//           "There is something wrong with the file you uploaded, Please try again",
//         );
//         // Optionally, handle error (e.g., show an error message to the user)
//       }
//     }
//   };

//   // const handleAddressProofFrontFileChange = async (event) => {
//   //     const { files } = event.target;
//   //     if (files.length > 0) {
//   //         const file = files[0];
//   //         await uploadAddressProofFront(file);
//   //         setAddressProofFront(file.name);
//   //     } else {
//   //         setAddressProofFront("");
//   //     }
//   // };
//   const [
//     uploadAddressProofFrontFileLoading,
//     setUploadAddressProofFrontFileLoading,
//   ] = useState(false);
//   const handleAddressProofFrontFileChange = async (event) => {
//     setErrorMessage("");
//     const file = event.target.files[0];
//     if (file) {
//       const formData = new FormData();
//       formData.append("file", file);
//       setUploadAddressProofFrontFileLoading(true);

//       try {
//         const response = await axios.post(
//           "https://tupperware-service.cloud/services/media/uploads",
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           },
//         );
//         if (response?.data?.success === true) {
//           // setAddressProofFront(file.name); // Display file name
//           setUploadAddressProofFrontFileLoading(false);
//           setAddressProofFront(response?.data?.filename); // Display file name
//           setAddressProofFrontFileURL(response?.data?.filename);

//           // console.log("File uploaded successfully:", response.data);
//         } else {
//           setUploadAddressProofFrontFileLoading(false);
//           setErrorMessage(
//             "There is something wrong with the file you uploaded, Please try again",
//           );
//         }

//         // console.log("File uploaded successfully:", response.data);
//         // Optionally, handle success (e.g., show a success message or update UI)
//       } catch (error) {
//         console.error("Error uploading file:", error);
//         setUploadAddressProofFrontFileLoading(false);
//         setErrorMessage(
//           "There is something wrong with the file you uploaded, Please try again",
//         );
//         // Optionally, handle error (e.g., show an error message to the user)
//       }
//     }
//   };
//   // const handleAddressProofBackFileChange = async (event) => {
//   //     const { files } = event.target;
//   //     if (files.length > 0) {
//   //         const file = files[0];
//   //         await uploadAddressProofBack(file);
//   //         setAddressProofBack(file.name);
//   //     } else {
//   //         setAddressProofBack("");
//   //     }
//   // };

//   const [
//     uploadAddressProofBackFileLoading,
//     setUploadAddressProofBackFileLoading,
//   ] = useState(false);
//   const handleAddressProofBackFileChange = async (event) => {
//     setErrorMessage("");
//     const file = event.target.files[0];
//     if (file) {
//       const formData = new FormData();
//       formData.append("file", file);
//       setUploadAddressProofBackFileLoading(true);

//       try {
//         const response = await axios.post(
//           "https://tupperware-service.cloud/services/media/uploads",
//           formData,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           },
//         );

//         if (response?.data?.success === true) {
//           // setAddressProofBack(file.name); // Display file name
//           setUploadAddressProofBackFileLoading(false);
//           setAddressProofBack(response?.data?.filename); // Display file name
//           setAddressProofBackFileURL(response?.data?.filename);
//           // console.log("File uploaded successfully:", response.data);
//         } else {
//           setUploadAddressProofBackFileLoading(false);
//           setErrorMessage(
//             "There is something wrong with the file you uploaded, Please try again",
//           );
//         }
//       } catch (error) {
//         setUploadAddressProofBackFileLoading(false);
//         console.error("Error uploading file:", error);
//         setErrorMessage(
//           "There is something wrong with the file you uploaded, Please try again",
//         );
//         // Optionally, handle error (e.g., show an error message to the user)
//       }
//     }
//   };

//   const [isConsent, setIsConsent] = useState(false);
//   // console.log("IS CONSENT", isConsent);
//   const [showTermsAndConditionsPopup, setShowTermsAndConditionsPopup] =
//     useState(false);
//   const [showTermsAndConsultantPopup, setShowTermsAndConsultantPopup] =
//     useState(false);
//   const [showOpportunityPopup, setShowOpportunityPopup] = useState(false);
//   const [showThankyouPopup, setShowThankyouPopup] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [selectedStateId, setSelectedStateId] = useState("");
//   const [selectedCityId, setSelectedCityId] = useState("");

//   const [permanentSelectedStateId, setPermanentSelectedStateId] = useState("");
//   const [permanentSelectedCityId, setPermanentSelectedCityId] = useState("");
//   // const [selectedPincodeId, setSelectedPincodeId] = useState('');
//   // console.log("selectedStateId", selectedStateId);
//   // console.log("selectedCityId", selectedCityId);
//   // console.log("selectedPincodeId",selectedPincodeId);

//   const handleStateChange = (e) => {
//     const stateId = e.target.value;
//     setSelectedStateId(stateId);
//     setFormData({
//       ...formData,
//       sameAddress: false,
//       currentLocationState: stateId,
//       currentLocationCity: "",
//       permanentLocationState: null, // Reset permanent address fields
//       permanentLocationCity: null,
//       permanentLocationPincode: "",
//       permanentAddress: "",
//     });
//   };

//   const handleCityChange = (e) => {
//     const cityId = e.target.value;
//     setSelectedCityId(cityId);
//     setFormData({
//       ...formData,
//       sameAddress: false,
//       currentLocationCity: cityId,
//       currentLocationPincode: "",
//       permanentLocationState: null, // Reset permanent address fields
//       permanentLocationCity: null,
//       permanentLocationPincode: "",
//       permanentAddress: "",
//     });
//   };

//   // const handlePincodeChange = (e) => {
//   //     const pincodeId = e.target.value;
//   //     setSelectedPincodeId(pincodeId);
//   //     setFormData({ ...formData, currentLocationPincodeId: pincodeId });
//   // };

//   const handlePincodeChange = (e) => {
//     const selectedPincode = e.target.value;
//     const selectedPincodeId =
//       e.target.options[e.target.selectedIndex].dataset.id; // Pincode ID

//     // const selectedPincodeId = e.target.options[e.target.selectedIndex].getAttribute('data-id'); // Pincode ID

//     setFormData({
//       ...formData,
//       sameAddress: false,
//       currentLocationPincode: selectedPincode,
//       currentLocationPincodeCode: selectedPincodeId,
//       permanentLocationState: null, // Reset permanent address fields
//       permanentLocationCity: null,
//       permanentLocationPincode: "",
//       permanentAddress: "",
//     });
//   };

//   const handleCheckboxChange = (event) => {
//     setFormData({
//       ...formData,
//       termsAccepted: event.target.checked,
//     });
//   };
//   const handleConsultantAgreementCheckboxChange = (event) => {
//     setFormData({
//       ...formData,
//       consultantAgreementAccepted: event.target.checked,
//     });
//   };

//   const handlePermanentStateChange = (e) => {
//     const stateId = e.target.value;
//     setPermanentSelectedStateId(stateId);
//     setFormData({
//       ...formData,
//       permanentLocationState: stateId,
//       permanentLocationCity: "",
//     });
//   };

//   const handlePermanentCityChange = (e) => {
//     const cityId = e.target.value;
//     setPermanentSelectedCityId(cityId);
//     setFormData({
//       ...formData,
//       permanentLocationCity: cityId,
//       permanentLocationPincode: "",
//     });
//   };

//   const handlePermanentPincodeChange = (e) => {
//     const selectedPincode = e.target.value;
//     const selectedPincodeId =
//       e.target.options[e.target.selectedIndex].dataset.id; // Pincode ID

//     setFormData({
//       ...formData,
//       permanentLocationPincode: selectedPincode,
//       permanentLocationPincodeCode: selectedPincodeId,
//     });
//   };

//   const filteredCities =
//     cities &&
//     cities.filter((city) => city.stateId === parseInt(selectedStateId));
//   const filteredPincodes =
//     pincodes &&
//     pincodes.filter((pincode) => pincode.cityId === parseInt(selectedCityId));

//   const filteredPermanentCities =
//     cities &&
//     cities.filter(
//       (city) =>
//         city.stateId ===
//         parseInt(permanentSelectedStateId || formData?.permanentLocationState),
//     );
//   const filteredPermanentPincodes =
//     pincodes &&
//     pincodes.filter(
//       (pincode) =>
//         pincode.cityId ===
//         parseInt(permanentSelectedCityId || formData?.permanentLocationCity),
//     );

//   const [otp, setOtp] = useState(null);
//   const [isOtpFocused, setIsOtpFocused] = useState(false);

//   const dataToSend = {
//     userName: formData.name,
//     mobileNo: formData.mobile,
//     emailId: formData.email,
//     // stateId: formData.currentLocationState,
//     // cityId: formData.currentLocationCity,
//     stateId: formData.currentLocationState,
//     cityId: formData.currentLocationCity,
//     assemblyId: null,
//     joinOrBuy: null,
//     status: null,
//     closedBy: null,
//     closedDate: null,
//     landmark: formData.currentAddress,
//     esclationStatus: null,
//     // consultant Id Jaa rhi h to B, aur agar nhi jaa rhi h to D
//     // {formData.consultantId !== "" ? "B" : "D" }
//     // userType: "C",
//     userType: formData.consultantId !== "" ? "B" : "D",
//     esclationToId: null,
//     remark: null,
//     acceptedDate: null,
//     contactedDateTime: null,
//     convertedDateTime: null,
//     gender: null,
//     address1: formData.permanentAddress,
//     // pincode: formData.currentLocationPincode,
//     pincode: formData.currentLocationPincodeCode,
//     // experienceCenterName: null,
//     experienceCenterName: "shopify",
//     createdBy: null,
//     modifiedBy: null,
//     otp: formData.otp,
//     consultantId: formData.consultantId,
//     isConsent: isConsent,
//     studioId: null,
//     dateOfBirth: formData.dob,
//     // photoFileName: formData.photo,
//     // photoFileName: photo,
//     photoFileName: photoFileURL,
//     // photoFileName: "",
//     // documentFileName: formData.addressProofFront,
//     // documentFileName: addressProofFront,
//     documentFileName: addressProofFrontFileURL,
//     // documentFileName: "",
//     // documentType: formData.addressProof,
//     documentType: formData.addressProof,
//     documentNo: formData.documentNumber,
//     pstateId: formData.permanentLocationState,
//     pcityId: formData.permanentLocationCity,
//     // ppincode: formData.permanentLocationPincode,
//     ppincode: formData.permanentLocationPincodeCode,
//     paddress: formData.permanentAddress,
//     // documentBackFileName: formData.addressProofBack
//     // documentBackFileName: ""
//     // documentBackFileName: addressProofBack
//     documentBackFileName: addressProofBackFileURL,
//   };

//   console.log("dataToSend", dataToSend);

//   // const registerUser = async (dataToSend) => {
//   //     try {
//   //         const response = await axios.post('https://tupperware-b78ebe08f4f4.herokuapp.com/services/user/register-user', dataToSend, {
//   //             headers: {
//   //                 'Content-Type': 'application/json',
//   //             },
//   //         });
//   //         console.log("Response is :=>",response)
//   //         return response;
//   //     } catch (error) {
//   //         console.error('API Error:', error);
//   //         throw error;
//   //     }
//   // };
//   const [registerUserLoading, setRegisterUserLoading] = useState(false);
//   const registerUser = async () => {
//     setRegisterUserLoading(true);

//     try {
//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         // url: 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/user/register-user',
//         url: "https://tupperware-service.cloud/services/user/register-user",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: JSON.stringify(dataToSend),
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           // console.log("Response is ==========>>>>>>>>>>>", JSON.stringify(response.data));
//           // console.log("Second Response is ==========>>>>>>>>>>>", response.data);
//           if (response?.data?.success === true) {
//             setMessage(response.data.message);
//             setIsSubmitted(true);
//             setRegisterUserLoading(false);
//           } else {
//             setErrorMessage(response.data.message);
//             setRegisterUserLoading(false);
//           }
//         })
//         .catch((error) => {
//           console.log(error);
//           setRegisterUserLoading(false);
//         });
//     } catch (error) {
//       setErrorMessage(
//         "There is something error in registration, Please try again",
//       );
//       setRegisterUserLoading(false);
//       console.error("API Error:", error);
//       throw error;
//     }
//   };
//   const [otpValidationLoading, setOtpValidationLoading] = useState(false);
//   const otpValidation = async () => {
//     setOtpValidationLoading(true);
//     try {
//       let config = {
//         method: "post",
//         maxBodyLength: Infinity,
//         // url: 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/user/register-user-verify',
//         url: "https://tupperware-service.cloud/services/user/register-user-verify",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: JSON.stringify(dataToSend),
//       };

//       axios
//         .request(config)
//         .then((response) => {
//           // console.log("OTP VALIDATION Response is ==========>>>>>>>>>>>", JSON.stringify(response.data));
//           // console.log("OTP VALIDATION Second Response is ==========>>>>>>>>>>>", response.data);
//           if (response?.data?.success === true) {
//             setMessage(response.data.message);
//             setOtpValidationLoading(false);
//             setShowThankyouPopup(true);
//             setTimeout(() => {
//               window.location.href = "https://www.shoptupperware.in/account";
//             }, 3000);
//           } else {
//             setErrorMessage(response.data.message);
//             setOtpValidationLoading(false);
//           }
//         })
//         .catch((error) => {
//           setErrorMessage(
//             "There is something error in registration, Please try again later.",
//           );
//           console.log(error);
//           setOtpValidationLoading(false);
//         });
//     } catch (error) {
//       console.error("API Error:", error);
//       setOtpValidationLoading(false);
//       setErrorMessage(error);
//       throw error;
//     }
//   };

//   const handleKeyDown = (e) => {
//     if (e.key === "Enter") {
//       e.preventDefault();
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         consultantId: e.target.value,
//       }));
//       //   if (formData.consultantId === "") {
//       //     setIsReferred(false);
//       //   } else {
//       //     setIsReferred(true);
//       //   }

//       // setIsReferred(false);
//     }
//   };

//   //   const handleTermsAndConditionsPopup = () => {
//   //     setShowTermsAndConditionsPopup(true);
//   //   };
//   const handleTermsAndConsultantPopup = () => {
//     setShowTermsAndConsultantPopup(true);
//   };
//   const handleCloseTermsAndConditionsPopup = () => {
//     formData.termsAccepted = false;
//     setShowTermsAndConditionsPopup(false);
//   };
//   const handleCloseTermsAndConsultantPopup = () => {
//     formData.consultantAgreementAccepted = false;
//     setShowTermsAndConsultantPopup(false);
//   };
//   const handleAgreeTermsAndConditions = () => {
//     formData.termsAccepted = true;
//     setShowTermsAndConditionsPopup(false);
//   };
//   const handleAgreeTermsAndConsultant = () => {
//     formData.consultantAgreementAccepted = true;
//     setShowTermsAndConsultantPopup(false);
//   };

//   const handleOpportunityPopup = () => {
//     setShowOpportunityPopup(true);
//   };
//   const handleCloseOpportunityPopup = () => {
//     setShowOpportunityPopup(false);
//   };

//   const handleOtpFocus = () => {
//     setIsOtpFocused(true);
//   };

//   const handleOtpBlur = () => {
//     if (!formData.otp) {
//       setIsOtpFocused(false);
//     }
//   };
//   const handleConsultantIdFocus = () => {
//     setIsConsultantIdFocused(true);
//   };

//   const handleConsultantIdBlur = () => {
//     if (!FormData.consultantId) {
//       setIsConsultantIdFocused(false);
//     }
//   };

//   return (
//     <div className="min-h-screen bg-white">
//       {/* Header Section */}
//       <div className="bg-red-400 p-4 flex justify-center items-center">
//         {/* <img src="/path/to/tupperware-logo.png" alt="Tupperware" className="h-12" /> */}
//         <h1 className="text-white text-xl font-bold">
//           <a
//             href="https://www.shoptupperware.in"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Tupperware Consultant Registration
//           </a>
//         </h1>
//       </div>

//       {/* Toggle Section */}
//       {/* <div className="flex justify-center items-center bg-white p-4 border-b">
//                 <label className="mr-4 text-gray-600">No one Referred</label>
//                 <label className="switch">
//                     <input type="checkbox" checked={isReferred || formData.consultantId !== ''}
//                         onChange={() => setIsReferred(!isReferred)} />
//                     <span className="slider round"></span>
//                 </label>
//                 <label className="ml-4 text-gray-600">Referred by Someone</label>
//             </div> */}

//       {/* {isReferred ? ( */}
//       {/* <div className="max-w-5xl mx-auto p-6">

//                     <div className="border border-teal-700 p-4 shadow-md hover:shadow-lg transition-shadow duration-300">
//                         <h2 className="text-teal-700 text-lg font-semibold mb-10">Enter Consultant ID or Mobile No. of Referrer</h2>
//                         <div className="relative mb-4">
//                             <input
//                                 type="text"
//                                 value={consultantId}
//                                 name="consultantId"
//                                 onChange={(e) => setConsultantId(e.target.value)}
//                                 // onChange={handleChange}
//                                 onFocus={handleConsultantIdFocus}
//                                 onBlur={handleConsultantIdBlur}
//                                 onKeyDown={handleKeyDown}
//                                 className="w-full border rounded px-4 py-2 focus:outline-none focus:border-teal-500"
//                             />
//                         </div>
//                     </div>
                    
//                 </div> */}

//       {/* ) : */}
//       {/* ( */}

//       <div className="max-w-5xl mx-auto p-6">
//         {/* Interest Section */}
//         {/* <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
//                             <h2 className="text-teal-700 text-lg font-semibold mb-4">Are you interested in</h2>
//                             <div className="flex space-x-4">
//                                 <label className="flex items-center text-gray-600">
//                                     <input type="radio" name="interest" value="Social Selling" onChange={handleChange} className="mr-2" /> Social Selling
//                                 </label>
//                                 <label className="flex items-center text-gray-600">
//                                     <input type="radio" name="interest" value="Direct Selling" onChange={handleChange} className="mr-2" /> Direct Selling
//                                 </label>
//                                 <label className="flex items-center text-gray-600">
//                                     <input type="radio" name="interest" value="Both" onChange={handleChange} className="mr-2" /> Both
//                                 </label>
//                             </div>
//                         </div> */}

//         <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
//           <h2 className="text-teal-700 text-lg font-semibold mb-5">
//             If you are referred by a consultant or Direct Seller
//           </h2>
//           <div className="relative mb-4">
//             <input
//               type="text"
//               // value={consultantId}
//               name="consultantId"
//               placeholder="Consultant Id or Mobile No. (Optional)"
//               // onChange={(e) => setConsultantId(e.target.value)}
//               onChange={handleChange}
//               // onChange={handleChange}
//               onFocus={handleConsultantIdFocus}
//               onBlur={handleConsultantIdBlur}
//               onKeyDown={handleKeyDown}
//               className="w-full border rounded px-4 py-2 focus:outline-none focus:border-teal-500"
//             />
//           </div>
//         </div>

//         {/* Location Section */}
//         <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
//           <h2 className="text-teal-700 text-lg font-semibold mb-4">
//             Choose your current location
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             {/* <div>
//                                     <label className="block text-gray-600 mb-1">Select State</label>
//                                     <select name="currentLocationState" onChange={handleChange} className="w-full border rounded px-4 py-2">
//                                         <option>Select State</option>
//                                     </select>
//                                 </div> */}
//             <div>
//               <label className="block text-gray-600 mb-1">Select State</label>
//               <select
//                 name="currentLocationState"
//                 onChange={handleStateChange}
//                 className="w-full border rounded px-4 py-2"
//               >
//                 <option value="">Select State</option>
//                 {states &&
//                   states.map((state) => (
//                     <option key={state.id} value={state.id}>
//                       {state.name}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             {/* <div>
//                                     <label className="block text-gray-600 mb-1">Select City</label>
//                                     <select name="currentLocationCity" onChange={handleChange} className="w-full border rounded px-4 py-2">
//                                         <option>Select City</option>
//                                     </select>
//                                 </div> */}

//             <div>
//               <label className="block text-gray-600 mb-1">Select City</label>
//               <select
//                 name="currentLocationCity"
//                 onChange={handleCityChange}
//                 value={formData.currentLocationCity}
//                 className="w-full border rounded px-4 py-2"
//                 disabled={!selectedStateId}
//               >
//                 <option value="" disabled>
//                   Select City
//                 </option>
//                 {filteredCities &&
//                   filteredCities.map((city) => (
//                     <option key={city.id} value={city.id}>
//                       {city.name}
//                     </option>
//                   ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-gray-600 mb-1">Select Pincode</label>
//               <select
//                 name="currentLocationPincode"
//                 onChange={handlePincodeChange}
//                 value={formData.currentLocationPincode}
//                 className="w-full border rounded px-4 py-2"
//                 disabled={!selectedCityId}
//               >
//                 <option value="" disabled>
//                   Select Pincode
//                 </option>
//                 {filteredPincodes ? (
//                   filteredPincodes.map((pincode) => (
//                     // <option key={pincode.id} value={pincode.id}>
//                     <option
//                       key={pincode.id}
//                       value={pincode.id}
//                       data-id={pincode.code}
//                     >
//                       {pincode.code}
//                     </option>
//                   ))
//                 ) : (
//                   <option value="" disabled>
//                     Select Pincode
//                   </option>
//                 )}
//               </select>
//             </div>
//             <div className="flex items-center">
//               <input
//                 type="checkbox"
//                 value={formData.sameAddress}
//                 checked={formData.sameAddress}
//                 name="sameAddress"
//                 onChange={handleChange}
//                 className="mr-2"
//               />
//               <label className="text-gray-600">
//                 Tick here if current and permanent address is the same.
//                 Permanent address should match the details in the address proof
//                 document uploaded by you.
//               </label>
//             </div>
//             <div className="">
//               <label className="block text-gray-600 mb-1">Address</label>
//               <input
//                 type="text"
//                 name="currentAddress"
//                 onChange={handleChange}
//                 className="w-full border rounded px-4 py-2"
//                 placeholder="Enter Address"
//               />
//             </div>
//           </div>
//         </div>
//         {/* Permanent Location Section */}
//         <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
//           <h2 className="text-teal-700 text-lg font-semibold mb-4">
//             Choose your permanent location
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-gray-600 mb-1">Select State</label>
//               <select
//                 value={formData?.permanentLocationState || ""}
//                 name="permanentLocationState"
//                 onChange={handlePermanentStateChange}
//                 className="w-full border rounded px-4 py-2"
//               >
//                 <option value="">Select State</option>
//                 {states &&
//                   states.map((state) => (
//                     <option key={state.id} value={state.id}>
//                       {state.name}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             <div>
//               <label className="block text-gray-600 mb-1">Select City</label>
//               <select
//                 name="permanentLocationCity"
//                 onChange={handlePermanentCityChange}
//                 value={formData?.permanentLocationCity || ""}
//                 // value={cities.find((item) => item.id === formData?.permanentLocationCity)?.code || '' }
//                 className="w-full border rounded px-4 py-2"
//                 // disabled={!permanentSelectedStateId}
//               >
//                 <option value="" disabled>
//                   Select City
//                 </option>
//                 {filteredPermanentCities &&
//                   filteredPermanentCities.map((city) => (
//                     <option key={city.id} value={city.id}>
//                       {city.name}
//                     </option>
//                   ))}
//               </select>
//             </div>

//             <div>
//               <label className="block text-gray-600 mb-1">Select Pincode</label>
//               <select
//                 name="permanentLocationPincode"
//                 onChange={handlePermanentPincodeChange}
//                 value={formData?.permanentLocationPincode || ""}
//                 // value={pincodes.find((item) => item.id === formData?.permanentLocationPincode)?.code || ''}
//                 className="w-full border rounded px-4 py-2"
//                 // disabled={!permanentSelectedCityId}
//               >
//                 <option value="" disabled>
//                   Select Pincode
//                 </option>
//                 {filteredPermanentPincodes &&
//                   filteredPermanentPincodes.map((pincode) => (
//                     <option
//                       key={pincode.id}
//                       value={pincode.id}
//                       data-id={pincode.code}
//                     >
//                       {pincode.code}
//                     </option>
//                   ))}
//               </select>
//             </div>
//             <div className="">
//               <label className="block text-gray-600 mb-1">Address</label>
//               <input
//                 type="text"
//                 name="permanentAddress"
//                 value={formData?.permanentAddress}
//                 onChange={handleChange}
//                 className="w-full border rounded px-4 py-2"
//                 placeholder="Enter Address"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Personal Details Section */}
//         <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
//           <h2 className="text-teal-700 text-lg font-semibold mb-4">
//             Fill in your details
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-gray-600 mb-1">Name</label>
//               <input
//                 type="text"
//                 name="name"
//                 onChange={handleChange}
//                 className="w-full border px-4 py-2"
//                 placeholder="Enter Name"
//               />
//             </div>
//             <div>
//               <label className="block text-gray-600 mb-1">Date of Birth</label>
//               <input
//                 type="date"
//                 name="dob"
//                 onChange={handleChange}
//                 className="w-full border rounded px-4 py-2"
//               />
//             </div>
//             <div>
//               <label className="block text-gray-600 mb-1">Mobile</label>
//               <input
//                 type="text"
//                 name="mobile"
//                 onChange={handleChange}
//                 className="w-full border rounded px-4 py-2"
//                 placeholder="Enter Mobile Number"
//               />
//             </div>
//             <div>
//               <label className="block text-gray-600 mb-1">Email</label>
//               <input
//                 type="email"
//                 name="email"
//                 onChange={handleChange}
//                 className="w-full border rounded px-4 py-2"
//                 placeholder="Enter Email"
//               />
//             </div>
//           </div>
//         </div>

//         {/* Upload Photo & Address Proof Section */}
//         <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
//           <h2 className="text-teal-700 text-lg font-semibold mb-4">
//             Upload Photo & Address Proof
//           </h2>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-gray-600 mb-1">
//                 Select Address Proof
//               </label>
//               <select
//                 className="w-full border rounded px-4 py-2"
//                 name="addressProof"
//                 // value={formData.addressProof}
//                 onChange={handleChange}
//               >
//                 <option value="">Select Proof Type</option>
//                 <option value="A">Aadhaar Card</option>
//                 <option value="V">Voter Id</option>
//                 <option value="P">Passport</option>
//                 <option value="pan">PAN Card</option>
//               </select>
//             </div>

//             <div>
//               <label className="block text-gray-600 mb-1">
//                 Enter Aadhaar/Voter/Passport No.
//               </label>
//               <input
//                 type="text"
//                 name="documentNumber"
//                 onChange={handleChange}
//                 className="w-full border rounded px-4 py-2"
//                 placeholder="Enter Document No."
//               />
//             </div>
//           </div>
//           <div className="mt-4">
//             {/* Upload Photo */}
//             {/* <div className="flex flex-col md:flex-row items-center mb-4">
//                                     <div>
//                                         <input
//                                             type="file"
//                                             onChange={handlePhotoFileChange}
//                                             id="photo"
//                                             className="hidden"
//                                         />
//                                         <label
//                                             htmlFor="photo"
//                                             className="bg-teal-600 text-white px-4 py-2 rounded cursor-pointer flex items-center space-x-2"
//                                         >
//                                             <span><FaCloudUploadAlt /></span>
//                                             <span>PHOTOGRAPH (PP SIZE)</span>
//                                         </label>
//                                     </div>

//                                     <div className={`ml-4 h-[30px] border-b ${photo ? "border-teal-600" : "border-gray-400"} flex-grow`}>
//                                         <span className="text-gray-700">{photo}</span>
//                                     </div>
//                                 </div> */}

//             <div className="flex flex-col md:flex-row items-center mb-4">
//               <div>
//                 <input
//                   type="file"
//                   onChange={handlePhotoFileChange}
//                   id="photo"
//                   className="hidden"
//                 />
//                 <label
//                   htmlFor="photo"
//                   className="bg-teal-600 text-white px-4 py-2 rounded cursor-pointer flex items-center space-x-2"
//                 >
//                   {uploadPhotoLoading === true ? (
//                     <svg
//                       className="animate-spin h-4 w-4 text-white"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8v8H4z"
//                       ></path>
//                     </svg>
//                   ) : (
//                     <FaCloudUploadAlt />
//                   )}
//                   <span>PHOTOGRAPH (PP SIZE)</span>
//                 </label>
//               </div>

//               <div
//                 className={`ml-4 h-[30px] border-b ${photo ? "border-teal-600" : "border-gray-400"} flex-grow`}
//               >
//                 <span className="text-gray-700">{photo}</span>
//               </div>
//             </div>

//             {/* Upload Address Proof (Front) */}
//             <div className="flex flex-col md:flex-row items-center mb-4">
//               <div>
//                 <input
//                   type="file"
//                   onChange={handleAddressProofFrontFileChange}
//                   id="addressProofFront"
//                   className="hidden"
//                 />
//                 <label
//                   htmlFor="addressProofFront"
//                   className="bg-teal-600 text-white px-4 py-2 rounded cursor-pointer flex items-center space-x-2"
//                 >
//                   {uploadAddressProofFrontFileLoading === true ? (
//                     <svg
//                       className="animate-spin h-4 w-4 text-white"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8v8H4z"
//                       ></path>
//                     </svg>
//                   ) : (
//                     <FaCloudUploadAlt />
//                   )}

//                   <span>ADDRESS PROOF (FRONT)</span>
//                 </label>
//               </div>

//               <div
//                 className={`ml-4 h-[30px] border-b ${addressProofFront ? "border-teal-600" : "border-gray-400"} flex-grow`}
//               >
//                 <span className="text-gray-700">{addressProofFront}</span>
//               </div>
//             </div>

//             {/* Upload Address Proof (Back) */}
//             <div className="flex flex-col md:flex-row items-center mb-4">
//               <div>
//                 <input
//                   type="file"
//                   onChange={handleAddressProofBackFileChange}
//                   id="addressProofBack"
//                   className="hidden"
//                 />
//                 <label
//                   htmlFor="addressProofBack"
//                   className="bg-teal-600 text-white px-4 py-2 rounded cursor-pointer flex items-center space-x-2"
//                 >
//                   {uploadAddressProofBackFileLoading === true ? (
//                     <svg
//                       className="animate-spin h-4 w-4 text-white"
//                       xmlns="http://www.w3.org/2000/svg"
//                       fill="none"
//                       viewBox="0 0 24 24"
//                     >
//                       <circle
//                         className="opacity-25"
//                         cx="12"
//                         cy="12"
//                         r="10"
//                         stroke="currentColor"
//                         strokeWidth="4"
//                       ></circle>
//                       <path
//                         className="opacity-75"
//                         fill="currentColor"
//                         d="M4 12a8 8 0 018-8v8H4z"
//                       ></path>
//                     </svg>
//                   ) : (
//                     <FaCloudUploadAlt />
//                   )}
//                   <span>ADDRESS PROOF (BACK)</span>
//                 </label>
//               </div>

//               <div
//                 className={`ml-4 h-[30px] border-b ${addressProofBack ? "border-teal-600" : "border-gray-400"} flex-grow`}
//               >
//                 <span className="text-gray-700">{addressProofBack}</span>
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="europe-container mx-auto px-4 py-6 relative">
//           {showTermsAndConditionsPopup && (
//             <>
//               <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
//               <div className="fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white w-[70vw] h-[70vh]  text-left ">
//                 <div className="max-w-[70vw] max-h-[60vh] p-6 md:p-8 break-words overflow-y-auto">
//                   <p className="text-xl pb-6">Terms & Conditions</p>
//                   <p>
//                     WHEREAS in consideration of Tupperware India Private Limited
//                     (“Tupperware” and/or “the Company”) appointing me as a
//                     Consultant of Tupperware and granting me the right to resell
//                     and distribute the products of Tupperware for
//                     margin/commission/incentive as per Tupperware’s business
//                     plan as explained to me and provided in the Tupperware
//                     Literature. I, the Consultant, hereby agree, undertake, and
//                     acknowledge that:
//                   </p>
//                   <ol className="pl-6">
//                     <li>
//                       1. The following words shall have the meaning as
//                       prescribed to them herein:
//                       <ol className="pl-6">
//                         <li>
//                           a. <span className="font-medium">"Distributor”</span>{" "}
//                           shall refer to the person authorised by Tupperware to
//                           service/train Tupperware Consultants.
//                         </li>
//                         <li>
//                           b. <span className="font-medium">“Product(s)”</span>{" "}
//                           shall refer to all products which Tupperware assigns
//                           its consultants to sell.
//                         </li>
//                         <li>
//                           c.{" "}
//                           <span className="font-medium">
//                             “Tupperware Literature”
//                           </span>{" "}
//                           shall refer to the various documents issued by
//                           Tupperware from time to time to govern the Tupperware
//                           business, including but not limited to these Terms and
//                           Conditions, Tupperware’s business plan, Code of
//                           Conduct, Terms as mentioned on Tupperware website,
//                           Return and Exchange Policy and Shipment and Payment
//                           Policy. Tupperware Literature is shown on the
//                           Tupperware’s website{" "}
//                           <a href="http://www.tupperwareindia.com">
//                             www.tupperwareindia.com
//                           </a>
//                           .
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       2. By executing the present agreement, I agree that I have
//                       attained the age of majority (18 years) and am legally
//                       competent and allowed to enter into this agreement. I
//                       undertake to provide government-issued documents for my
//                       KYC. I further undertake that I have neither been
//                       convicted of a criminal offence nor declared bankrupt
//                       during the last five years from the date of execution of
//                       the present agreement.
//                     </li>
//                     <li>
//                       3. There are no fees or charges required to join as
//                       Tupperware’s Consultant, nor payment of any kind for any
//                       sales demonstration or material cost is required. I agree
//                       that I am an independent contractor having a
//                       principal-to-principal relationship with Tupperware by way
//                       of this Agreement. I am neither an employee nor an agent
//                       of Tupperware. I am not authorised to bind the Company
//                       under any circumstance or legal document; I cannot create
//                       any obligation to be performed by the Company. Upon
//                       joining, Tupperware may associate me with a Distributor
//                       for ease of coordination and supply.
//                     </li>
//                     <li>
//                       4. I understand that any margins and incentives are based
//                       on sale of Products as per Tupperware’s business plan and
//                       no payment shall be made or requested for the
//                       recruitment/enrolment of prospective consultants.
//                     </li>
//                     <li>
//                       5. I understand that I will not be required to purchase
//                       any goods or services for an amount or quantity which I
//                       cannot reasonably sell or consume.
//                     </li>
//                     <li>
//                       6. I have undertaken orientation session and been provided
//                       with fair and accurate information on all aspects of
//                       direct selling business including the margins and
//                       incentives.
//                     </li>
//                     <li>
//                       7. I shall provide a self-attested copy of my PAN. I
//                       understand that if I fail to provide a copy of my PAN
//                       card, tax deduction as per the provisions of The Income
//                       Tax Act shall apply.
//                     </li>
//                     <li>
//                       8. I understand that Tupperware reserves the right to
//                       accept or reject my application as a consultant, with or
//                       without assigning any reasons. Submitting the present
//                       application shall not give me with any right as a
//                       Consultant unless my application is approved by
//                       Tupperware.
//                     </li>
//                     <li>
//                       9. Upon joining Tupperware as a Consultant, I shall have
//                       the right to withdraw this agreement within 10 working
//                       days from the date of joining (“Withdrawal Period”),
//                       without penalty and without giving any reasons, by giving
//                       Tupperware notice of my intention to do so in writing via
//                       e-mail at care@tupperwareindia.com. If I exercise my right
//                       to withdraw from this agreement during the Withdrawal
//                       Period:
//                       <ol className="pl-6">
//                         <li>
//                           a. I will be required to destroy all records and
//                           copies of the Tupperware’s business plan previously
//                           provided to me; and
//                         </li>
//                         <li>
//                           b. this agreement will be deemed to have been
//                           terminated such that I will be deemed to never have
//                           been appointed as a Consultant.this agreement will be
//                           deemed to have been terminated such that I will be
//                           deemed to never have been appointed as a Consultant.
//                         </li>
//                       </ol>
//                     </li>
//                   </ol>
//                   <p>
//                     If I do not exercise my right to withdraw from this
//                     agreement within the Withdrawal Period, I will be deemed to
//                     have accepted all terms and conditions contained in this
//                     agreement and in the Tupperware Literature.
//                   </p>
//                   <ol className="pl-6">
//                     <li>
//                       10. I am only authorised to sell Products as per direct
//                       selling model in accordance with the Tupperware Literature
//                       and applicable law. However, I am not allowed to sell the
//                       Products through any of the following mechanism unless it
//                       is pre-approved by Tupperware in writing:
//                       <ol className="pl-6">
//                         <li>
//                           a. internet/online selling (e.g. e-commerce
//                           website(s), through any other web site(s), social
//                           media, chat room, bulletin board or other similar
//                           service(s) to promote or sell the Product(s));
//                         </li>
//                         <li>
//                           b. retail trade including but not limited to shops,
//                           supermarkets, stalls, kiosks and exhibitions;
//                         </li>
//                         <li>c. business to business sales;</li>
//                         <li>
//                           d. export any of the products outside India, nor sell
//                           to anyone who intends to export the Products outside
//                           India or is suspected to export the Products outside
//                           India without the prior written consent of Tupperware;
//                           And
//                         </li>
//                         <li>
//                           e. any other form of sales channels which are not in
//                           accordance with Tupperware Literature or applicable
//                           law.
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       11. Attending weekly assembly organized by Tupperware
//                       through Distributor is an important aspect of the business
//                       as it provides an insight about various Products/ideas and
//                       will help me in generating sales and ensuring customer
//                       satisfaction, along with obtaining suitable training to
//                       carry out my responsibilities under this Agreement.
//                     </li>
//                     <li>
//                       12. I am entitled to terminate this agreement for any
//                       reason at any time by submitting a 30-day prior written
//                       notice to Tupperware and subject to clearance of all my
//                       payment obligations.
//                     </li>
//                     <li>
//                       13. This agreement shall deemed to be terminated if I have
//                       not placed any order for purchase of goods for a period as
//                       determined by the prevailing Company policy, since the
//                       date of this agreement or since the date of the last order
//                       for purchase of goods placed by me, whichever is the
//                       later. The term of this agreement will otherwise continue
//                       to remain in force, unless terminated by either of the
//                       Parties as per the Terms and Conditions provided herein
//                       and other Tupperware Literature.
//                     </li>
//                     <li>
//                       14. I acknowledge that Tupperware can immediately
//                       terminate this agreement if Tupperware has reasonable
//                       grounds to believe that:
//                       <ol className="pl-6">
//                         <li>
//                           a. I have provided any wrong information regarding my
//                           eligibility as Consultant to Tupperware in this
//                           agreement, at the time of joining or thereafter,
//                         </li>
//                         <li>
//                           b. I have misrepresented about Tupperware’s
//                           business/Products in any manner,
//                         </li>
//                         <li>
//                           c. I have breached any terms or conditions of this
//                           agreement or other Tupperware Literature,
//                         </li>
//                         <li>
//                           d. I have failed to pay my payment obligations to
//                           Tupperware in a timely manner,
//                         </li>
//                         <li>
//                           e. if I am found involved in any act of commission or
//                           omission which discredits the Company’s brand
//                           name/products/literature, or
//                         </li>
//                         <li>
//                           f. if I am found to be in breach of the terms and
//                           conditions contained herein, any rules in the
//                           Tupperware Literature, any applicable laws including
//                           the Direct Selling Guidelines/regulations and/or
//                           Consumer Protection (Direct Selling) Rules, 2021 and
//                           subsequent amendments, if any.
//                         </li>
//                         <li>
//                           g. If I am found to contravene or breach any of the
//                           provisions of these Codes. The termination is
//                           effective on the date indicated in the written
//                           notification from Tupperware to me. I will have no
//                           further claim against Tupperware as a result of the
//                           termination.
//                         </li>
//                         <li>
//                           h. If terminated as a Consultant then I am not
//                           permitted, either directly or indirectly, to conduct
//                           or participate in any business activities related to
//                           Tupperware and is not entitled to receive further
//                           payment and reward for bonuses, commissions or any
//                           other awards whether accruing before or after the
//                           termination date.
//                         </li>
//                         <li>
//                           i. Tupperware may at its sole discretion, suspend my
//                           account, pending investigation of any alleged breaches
//                           to these Codes. During this suspension, no commission
//                           or bonuses will be paid. Sales and/or new recruits
//                           will not count towards any sales force promotion that
//                           may be in place.
//                         </li>
//                         <li>
//                           j. Tupperware reserves the right to claim damages from
//                           me if I am found breaching of these Codes and have
//                           been involved in activities that may have caused
//                           financial losses or otherwise to Tupperware.
//                         </li>
//                         <li>
//                           k. If terminated as a Consultant then I shall not
//                           influence existing Consultant and employees of
//                           Tupperware in any manner that may disrupt the
//                           operations and image of Tupperware.
//                         </li>
//                         <li>
//                           l. If terminated as a Consultant then I will not be
//                           accepted again as a Tupperware Consultant.
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       15. I agree and assume full and independent responsibility
//                       for discharge of statutory and regulatory liability in
//                       taxes, duties, levies, cess and other governmental fees of
//                       any nature as levied from time to time pursuant to the
//                       applicable laws of India, in relation to my purchase and
//                       sale of goods and services and any situation which arises
//                       due to my execution of the present agreement.
//                     </li>
//                     <li>
//                       16. I understand that with respect to the Tupperware’s
//                       goods sold by me, I may only extend to end customers such
//                       warranty as specified by the Company.
//                     </li>
//                     <li>
//                       17. Except as specifically provided above, Tupperware
//                       shall not be liable in any manner to me for any loss or
//                       damages of any nature, including consequential damages and
//                       loss of earnings arising after my purchase of the
//                       Products.
//                     </li>
//                     <li>
//                       18. I shall:
//                       <ol className="pl-6">
//                         <li>
//                           a. at the initiation of any sale representation,
//                           truthfully and clearly identify myself, disclose that
//                           I am a Consultant of Tupperware, the address of place
//                           of business, the nature of goods or services sold and
//                           the purpose of such solicitation to the
//                           prospect/consumer;
//                         </li>
//                         <li>
//                           b. make an offer to sell to the prospect/consumer by
//                           providing accurate and complete information,
//                           demonstration of goods and services, prices, credit
//                           terms, terms of payment, return, exchange, refund
//                           policy, return policy, terms of guarantee and
//                           after-sale service;
//                         </li>
//                         <li>
//                           c. I understand that the order form will identify
//                           Tupperware as the direct selling entity, me as the
//                           Consultant and shall contain the name, address,
//                           registration number, identity proof issued by
//                           Tupperware and contact number of the Consultant ,
//                           complete description of the goods or services to be
//                           supplied, the country of origin of the goods, the
//                           order date, the total amount to be paid by the
//                           consumer, the time and place for inspection of the
//                           sample and delivery of goods, consumer's rights to
//                           cancel the order or to return the Product in saleable
//                           condition and avail full refund on sums paid as per
//                           Company’s policy and complete details regarding the
//                           complaint redressal mechanism of Tupperware;
//                         </li>
//                         <li>
//                           d. obtain goods and service tax registration,
//                           Permanent Account Number registration, all applicable
//                           trade registrations and licenses when applicable;
//                         </li>
//                         <li>
//                           e. comply with the requirements of applicable laws,
//                           rules and regulations for sale of a product;
//                         </li>
//                         <li>
//                           f. ensure that actual Product delivered to the buyer
//                           matches with the description of the Product given and
//                           Product ordered; and
//                         </li>
//                         <li>
//                           g. take appropriate steps to ensure the protection of
//                           all sensitive personal information provided by the
//                           consumer in accordance with the applicable laws for
//                           the time being in force and ensure adequate safeguards
//                           to prevent access to, or misuse of such data by
//                           unauthorized persons.
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       19. I shall not:
//                       <ol className="pl-6">
//                         <li>
//                           a. visit a consumer's premises without Tupperware’s
//                           identity card and prior appointment or the consumer’s
//                           consent;
//                         </li>
//                         <li>
//                           b. provide any literature to a prospective customer,
//                           which has not been approved by Tupperware;
//                         </li>
//                         <li>
//                           c. use any misleading, deceptive, or unfair trade
//                           practices during the sale;
//                         </li>
//                         <li>
//                           d. require a prospective customer to purchase any
//                           literature or sales demonstration equipment;
//                         </li>
//                         <li>
//                           e. during a sale, make any claim that is not
//                           consistent with claims authorized by Tupperware;
//                         </li>
//                         <li>
//                           f. conduct fraudulent sales activities or false or
//                           misleading representations or engage any other form of
//                           fraud, coercion, harassment, or unconscionable or
//                           unlawful means;
//                         </li>
//                         <li>
//                           g. indulge in mis-selling of Products or services to
//                           consumers;
//                         </li>
//                         <li>
//                           h. refuse to take back spurious goods or deficient
//                           services and refund the consideration paid for goods
//                           and services provided;
//                         </li>
//                         <li>
//                           i. charge any entry fee or subscription fee to any
//                           individual;
//                         </li>
//                         <li>
//                           j. induce consumers to make a purchase based upon the
//                           representation that they can reduce or recover the
//                           price by referring prospective customers to the
//                           Consultant for similar purchases;
//                         </li>
//                         <li>
//                           k. promote/participate in a pyramid scheme and/or
//                           money circulation scheme or enroll any person to such
//                           schemes.
//                         </li>
//                         <li>
//                           l. export any of the products outside India, nor sell
//                           to anyone who intends to export the Products outside
//                           India or is suspected to export the Products outside
//                           India without the prior written consent of Tupperware
//                         </li>
//                         <li>
//                           m. sell the Products to anyone who has been
//                           blacklisted by Tupperware or anyone who is suspected
//                           to have been engaged in unlawful sale.
//                         </li>
//                         <li>
//                           n. Sell the products to anyone who intends to further
//                           sell Tupperware products across any channels and not
//                           limited to retail shops, e-commerce sites, Business to
//                           business etc unless having written confirmation from
//                           Tupperware
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       20. This agreement is entered on a personal basis and may
//                       not be assigned or transferred by me to any third party
//                       (including known or unknown) without the written consent
//                       of Tupperware.
//                     </li>
//                     <li>
//                       21. If any provision of these terms & conditions is found
//                       to be invalid or unenforceable, the remaining provisions
//                       shall remain in full force and effect.
//                     </li>
//                     <li>
//                       22. Tupperware reserves its right to modify, alter, amend,
//                       or re-enact the present terms and conditions and all
//                       Tupperware Literature at any time. Any such modification,
//                       alteration or amendment will become effective from the
//                       date of its publication on our website{" "}
//                       <a href="http://www.tupperwareindia.com">
//                         www.tupperwareindia.com
//                       </a>{" "}
//                       and my continuation of the Tupperware business shall
//                       constitute as my consent to any changed policies.
//                     </li>
//                     <li>
//                       23. This Agreement shall be governed by and construed in
//                       accordance with the laws of the India, The parties agree
//                       that the proper venue of the adjudication of any dispute
//                       will be in the courts of New Delhi, India. In the event of
//                       any dispute arising under this Agreement (including under
//                       any Services Schedule, the parties shall attempt for a
//                       period of thirty (30) days after receipt by a party of
//                       written request from the other party to resolve the
//                       dispute by amicable settlement. If the parties are unable
//                       to do so within such thirty (30) day period, such dispute
//                       shall be settled by arbitration in accordance with the
//                       Delhi International Arbitration Center, Delhi High Court
//                       (“DIAC”) Arbitration Rules in force at the time of the
//                       commencement of the arbitration. There shall be one
//                       arbitrator agreed by the parties within fifteen (15) days
//                       of a party’s written request for arbitration. If the
//                       parties are unable to agree on such arbitrator, an
//                       arbitrator shall be appointed by the DIAC in accordance
//                       with its Arbitration Rules. Any arbitration award may be
//                       enforced in the competent courts of New Delhi, India. Each
//                       party shall bear its own costs in connection with any
//                       arbitration hereunder, however the prevailing party in any
//                       arbitration shall be entitled to reimbursement of its
//                       reasonable arbitration costs, and its reasonable costs
//                       incurred in any enforcement of an arbitration award.
//                       Nothing herein shall prevent a party from seeking
//                       injunctive relief (or any other provisional remedy) from
//                       any court having jurisdiction over the parties and the
//                       subject matter of the dispute as is necessary to protect a
//                       party’s proprietary rights.
//                     </li>
//                     <li>
//                       24. The liability of Tupperware is limited to the lesser
//                       of a) actual damages or loss accessed by the arbitrator b)
//                       the total commission earned by the Consultant during the
//                       six months period preceding the date of the dispute. No
//                       such limitation of liability is applicable on Tupperware.
//                     </li>
//                     <li>
//                       25. I expressly agree and consent that Tupperware may
//                       collect, record, organize, store, update or modify,
//                       retrieve, consult, use, consolidate, block, erase or
//                       destroy, or otherwise process, through automated means or
//                       manual processing, my personal data, including my
//                       sensitive personal information, set out in this Agreement
//                       and/or otherwise provided by me or processed by Tupperware
//                       in the course of or in connection with my application or
//                       subsequent relationship with Tupperware. I further
//                       expressly agree and consent that Tupperware may share,
//                       disclose, transmit or transfer my personal data, including
//                       my sensitive personal data, to third parties (including
//                       but not limited to Tupperware’s parent
//                     </li>
//                     <li>
//                       26. I have read and understood all the Tupperware
//                       Literature, and understand that Tupperware has the right
//                       to change any of them from time to time and I shall keep
//                       myself updated with the same.
//                     </li>
//                     <li>
//                       27.{" "}
//                       <span className="font-medium">
//                         I hereby confirm that I have read, understood and agreed
//                         to the terms and conditions of this agreement. I will
//                         indicate my consent though clicking “consent” in the
//                         next screen or by signing on the Consultant agreement if
//                         hard copy is provided to me.
//                       </span>
//                     </li>
//                   </ol>
//                 </div>

//                 <div className="fixed z-10 bottom-0 left-1/2 transform -translate-x-1/2 pr-2 gap-3 md:pr-8 md:gap-7 flex justify-end items-center w-[70vw] h-[10vh] bg-white">
//                   <div>
//                     <button
//                       className="pt-2 pb-2 pr-4 pl-4 border-[1px] border-grey"
//                       onClick={handleAgreeTermsAndConditions}
//                     >
//                       AGREE
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       className="pt-2 pb-2 pr-4 pl-4 border-[1px] border-grey"
//                       onClick={handleCloseTermsAndConditionsPopup}
//                     >
//                       DISAGREE
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//         <div className="europe-container mx-auto px-4 py-6 relative">
//           {showTermsAndConsultantPopup && (
//             <>
//               <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
//               <div className="fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white w-[70vw] h-[70vh]  text-left ">
//                 <div className="max-w-[70vw] max-h-[60vh] p-6 md:p-8 break-words overflow-y-auto">
//                   <p className="text-xl pb-6 text-blue">Terms & Conditions</p>
//                   <p>
//                     WHEREAS in consideration of Tupperware India Private Limited
//                     ('Tupperware' and/or 'the Company') appointing me as a
//                     Consultant of Tupperware and granting me the right to resell
//                     and distribute the products of Tupperware for
//                     margin/commission/incentive as per Tupperware’s business
//                     plan as explained to me and provided in the Tupperware
//                     Literature. I, the Consultant, hereby agree, undertake, and
//                     acknowledge that:{" "}
//                   </p>
//                   <ol className="pl-6">
//                     <li>
//                       1. The following words shall have the meaning as
//                       prescribed to them herein:
//                       <ol className="pl-6">
//                         <li>
//                           a. <span className="font-medium">"Distributor”</span>{" "}
//                           shall refer to the person authorised by Tupperware to
//                           service/train Tupperware Consultants.{" "}
//                         </li>
//                         <li>
//                           b. <span className="font-medium">“Product(s)”</span>{" "}
//                           shall refer to all products which Tupperware assigns
//                           its consultants to sell.
//                         </li>
//                         <li>
//                           c.{" "}
//                           <span className="font-medium">
//                             “Tupperware Literature”
//                           </span>{" "}
//                           shall refer to the various documents issued by
//                           Tupperware from time to time to govern the Tupperware
//                           business, including but not limited to these Terms and
//                           Conditions, Tupperware’s business plan, Code of
//                           Conduct, Terms as mentioned on Tupperware website,
//                           Return and Exchange Policy and Shipment and Payment
//                           Policy. Tupperware Literature is shown on the
//                           Tupperware’s website{" "}
//                           <a href="https://www.shoptupperware.in/">
//                             https://www.shoptupperware.in/
//                           </a>
//                           .
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       2. By executing the present agreement, I agree that I have
//                       attained the age of majority (18 years) and am legally
//                       competent and allowed to enter into this agreement. I
//                       undertake to provide government-issued documents for my
//                       KYC. I further undertake that I have neither been
//                       convicted of a criminal offence nor declared bankrupt
//                       during the last five years from the date of execution of
//                       the present agreement.
//                     </li>
//                     <li>
//                       3. There are no fees or charges required to join as
//                       Tupperware’s Consultant, nor payment of any kind for any
//                       sales demonstration or material cost is required. I agree
//                       that I am an independent contractor having a principal-to-
//                       principal relationship with Tupperware by way of this
//                       Agreement. I am neither an employee nor an agent of
//                       Tupperware. I am not authorised to bind the Company under
//                       any circumstance or legal document; I cannot create any
//                       obligation to be performed by the Company. Upon joining,
//                       Tupperware may associate me with a Distributor for ease of
//                       coordination and supply.
//                     </li>
//                     <li>
//                       4. I understand that any margins and incentives are based
//                       on sale of Products as per Tupperware’s business plan and
//                       no payment shall be made or requested for the
//                       recruitment/enrolment of prospective consultants.
//                     </li>
//                     <li>
//                       5. I understand that I will not be required to purchase
//                       any goods or services for an amount or quantity which I
//                       cannot reasonably sell or consume.
//                     </li>
//                     <li>
//                       6. I have undertaken orientation session and been provided
//                       with fair and accurate information on all aspects of
//                       direct selling business including the margins and
//                       incentives.
//                     </li>
//                     <li>
//                       7. I shall provide a self-attested copy of my PAN. I
//                       understand that if I fail to provide a copy of my PAN
//                       card, tax deduction as per the provisions of The Income
//                       Tax Act shall apply.
//                     </li>
//                     <li>
//                       8. I understand that Tupperware reserves the right to
//                       accept or reject my application as a consultant, with or
//                       without assigning any reasons. Submitting the present
//                       application shall not give me with any right as a
//                       Consultant unless my application is approved by
//                       Tupperware.
//                     </li>
//                     <li>
//                       9. Upon joining Tupperware as a Consultant, I shall have
//                       the right to withdraw this agreement within 10 working
//                       days from the date of joining ('Withdrawal Period'),
//                       without penalty and without giving any reasons, by giving
//                       Tupperware notice of my intention to do so in writing via
//                       e-mail at care@tupperwareindia.com. If I exercise my right
//                       to withdraw from this agreement during the Withdrawal
//                       Period:
//                       <ol className="pl-6">
//                         <li>
//                           (i) I will be required to destroy all records and
//                           copies of the Tupperware’s business plan previously
//                           provided to me; and
//                         </li>
//                         <li>
//                           (ii) this agreement will be deemed to have been
//                           terminated such that I will be deemed to never have
//                           been appointed as a Consultant.this agreement will be
//                           deemed to have been terminated such that I will be
//                           deemed to never have been appointed as a Consultant.
//                           If I do not exercise my right to withdraw from this
//                           agreement within the Withdrawal Period, I will be
//                           deemed to have accepted all terms and conditions
//                           contained in this agreement and in the Tupperware
//                           Literature.{" "}
//                         </li>
//                       </ol>
//                     </li>
//                   </ol>
//                   {/* <p>If I do not exercise my right to withdraw from this agreement within the Withdrawal Period, I will be deemed to have accepted all terms and conditions contained in this agreement and in the Tupperware Literature.</p> */}
//                   <ol className="pl-6">
//                     <li>
//                       10. I am only authorised to sell Products as per direct
//                       selling model in accordance with the Tupperware Literature
//                       and applicable law. However, I am not allowed to sell the
//                       Products through any of the following mechanism unless it
//                       is pre-approved by Tupperware in writing:
//                       <ol className="pl-6">
//                         <li>
//                           a. internet/online selling (e.g. e-commerce
//                           website(s), through any other web site(s), social
//                           media, chat room, bulletin board or other similar
//                           service(s) to promote or sell the Product(s));{" "}
//                         </li>
//                         <li>
//                           b. retail trade including but not limited to shops,
//                           supermarkets, stalls, kiosks and exhibitions;{" "}
//                         </li>
//                         <li>c. business to business sales;</li>
//                         <li>
//                           d. export any of the products outside India, nor sell
//                           to anyone who intends to export the Products outside
//                           India or is suspected to export the Products outside
//                           India without the prior written consent of Tupperware;
//                           And{" "}
//                         </li>
//                         <li>
//                           e. any other form of sales channels which are not in
//                           accordance with Tupperware Literature or applicable
//                           law.{" "}
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       11. Attending weekly assembly organized by Tupperware
//                       through Distributor is an important aspect of the business
//                       as it provides an insight about various Products/ideas and
//                       will help me in generating sales and ensuring customer
//                       satisfaction, along with obtaining suitable training to
//                       carry out my responsibilities under this Agreement.
//                     </li>
//                     <li>
//                       12. I am entitled to terminate this agreement for any
//                       reason at any time by submitting a 30-day prior written
//                       notice to Tupperware and subject to clearance of all my
//                       payment obligations.{" "}
//                     </li>
//                     <li>
//                       13. This agreement shall deemed to be terminated if I have
//                       not placed any order for purchase of goods for a period as
//                       determined by the prevailing Company policy, since the
//                       date of this agreement or since the date of the last order
//                       for purchase of goods placed by me, whichever is the
//                       later. The term of this agreement will otherwise continue
//                       to remain in force, unless terminated by either of the
//                       Parties as per the Terms and Conditions provided herein
//                       and other Tupperware Literature.{" "}
//                     </li>
//                     <li>
//                       14. I acknowledge that Tupperware can immediately
//                       terminate this agreement if Tupperware has reasonable
//                       grounds to believe that:
//                       <ol className="pl-6">
//                         <li>
//                           a. I have provided any wrong information regarding my
//                           eligibility as Consultant to Tupperware in this
//                           agreement, at the time of joining or thereafter,{" "}
//                         </li>
//                         <li>
//                           b. I have misrepresented about Tupperware’s
//                           business/Products in any manner,{" "}
//                         </li>
//                         <li>
//                           c. I have breached any terms or conditions of this
//                           agreement or other Tupperware Literature,{" "}
//                         </li>
//                         <li>
//                           d. I have failed to pay my payment obligations to
//                           Tupperware in a timely manner,
//                         </li>
//                         <li>
//                           e. if I am found involved in any act of commission or
//                           omission which discredits the Company’s brand
//                           name/products/literature, or{" "}
//                         </li>
//                         <li>
//                           f. if I am found to be in breach of the terms and
//                           conditions contained herein, any rules in the
//                           Tupperware Literature, any applicable laws including
//                           the Direct Selling Guidelines/regulations and/or
//                           Consumer Protection (Direct Selling) Rules, 2021 and
//                           subsequent amendments, if any.{" "}
//                         </li>
//                         <li>
//                           g. If I am found to contravene or breach any of the
//                           provisions of these Codes. The termination is
//                           effective on the date indicated in the written
//                           notification from Tupperware to me. I will have no
//                           further claim against Tupperware as a result of the
//                           termination.{" "}
//                         </li>
//                         <li>
//                           h. If terminated as a Consultant then I am not
//                           permitted, either directly or indirectly, to conduct
//                           or participate in any business activities related to
//                           Tupperware and is not entitled to receive further
//                           payment and reward for bonuses, commissions or any
//                           other awards whether accruing before or after the
//                           termination date.{" "}
//                         </li>
//                         <li>
//                           i. Tupperware may at its sole discretion, suspend my
//                           account, pending investigation of any alleged breaches
//                           to these Codes. During this suspension, no commission
//                           or bonuses will be paid. Sales and/or new recruits
//                           will not count towards any sales force promotion that
//                           may be in place.{" "}
//                         </li>
//                         <li>
//                           j. Tupperware reserves the right to claim damages from
//                           me if I am found breaching of these Codes and have
//                           been involved in activities that may have caused
//                           financial losses or otherwise to Tupperware.{" "}
//                         </li>
//                         <li>
//                           k. If terminated as a Consultant then I shall not
//                           influence existing Consultant and employees of
//                           Tupperware in any manner that may disrupt the
//                           operations and image of Tupperware.{" "}
//                         </li>
//                         <li>
//                           l. If terminated as a Consultant then I will not be
//                           accepted again as a Tupperware Consultant.{" "}
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       15. I agree and assume full and independent responsibility
//                       for discharge of statutory and regulatory liability in
//                       taxes, duties, levies, cess and other governmental fees of
//                       any nature as levied from time to time pursuant to the
//                       applicable laws of India, in relation to my purchase and
//                       sale of goods and services and any situation which arises
//                       due to my execution of the present agreement.{" "}
//                     </li>
//                     <li>
//                       16. I understand that with respect to the Tupperware’s
//                       goods sold by me, I may only extend to end customers such
//                       warranty as specified by the Company.{" "}
//                     </li>
//                     <li>
//                       17. Except as specifically provided above, Tupperware
//                       shall not be liable in any manner to me for any loss or
//                       damages of any nature, including consequential damages and
//                       loss of earnings arising after my purchase of the
//                       Products.{" "}
//                     </li>
//                     <li>
//                       18. I shall:
//                       <ol className="pl-6">
//                         <li>
//                           a. at the initiation of any sale representation,
//                           truthfully and clearly identify myself, disclose that
//                           I am a Consultant of Tupperware, the address of place
//                           of business, the nature of goods or services sold and
//                           the purpose of such solicitation to the
//                           prospect/consumer;{" "}
//                         </li>
//                         <li>
//                           b. make an offer to sell to the prospect/consumer by
//                           providing accurate and complete information,
//                           demonstration of goods and services, prices, credit
//                           terms, terms of payment, return, exchange, refund
//                           policy, return policy, terms of guarantee and
//                           after-sale service;{" "}
//                         </li>
//                         <li>
//                           c. provide an order form to the consumer at or prior
//                           to the time of the initial sale. I understand that the
//                           order form will identify Tupperware as the direct
//                           selling entity, me as the Consultant and shall contain
//                           the name, address, registration number, identity proof
//                           issued by Tupperware and contact number of the
//                           Consultant , complete description of the goods or
//                           services to be supplied, the country of origin of the
//                           goods, the order date, the total amount to be paid by
//                           the consumer, the time and place for inspection of the
//                           sample and delivery of goods, consumer's rights to
//                           cancel the order or to return the Product in saleable
//                           condition and avail full refund on sums paid as per
//                           Company’s policy and complete details regarding the
//                           complaint redressal mechanism of Tupperware;{" "}
//                         </li>
//                         <li>
//                           d. obtain goods and service tax registration,
//                           Permanent Account Number registration, all applicable
//                           trade registrations and licenses when applicable;{" "}
//                         </li>
//                         <li>
//                           e. comply with the requirements of applicable laws,
//                           rules and regulations for sale of a product;
//                         </li>
//                         <li>
//                           f. ensure that actual Product delivered to the buyer
//                           matches with the description of the Product given and
//                           Product ordered; and{" "}
//                         </li>
//                         <li>
//                           g. take appropriate steps to ensure the protection of
//                           all sensitive personal information provided by the
//                           consumer in accordance with the applicable laws for
//                           the time being in force and ensure adequate safeguards
//                           to prevent access to, or misuse of such data by
//                           unauthorized persons.{" "}
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       19. I shall not:
//                       <ol className="pl-6">
//                         <li>
//                           a. visit a consumer's premises without Tupperware’s
//                           identity card and prior appointment or the consumer’s
//                           consent;
//                         </li>
//                         <li>
//                           b. provide any literature to a prospective customer,
//                           which has not been approved by Tupperware;
//                         </li>
//                         <li>
//                           c. use any misleading, deceptive, or unfair trade
//                           practices during the sale;
//                         </li>
//                         <li>
//                           d. require a prospective customer to purchase any
//                           literature or sales demonstration equipment;
//                         </li>
//                         <li>
//                           e. during a sale, make any claim that is not
//                           consistent with claims authorized by Tupperware;
//                         </li>
//                         <li>
//                           f. conduct fraudulent sales activities or false or
//                           misleading representations or engage any other form of
//                           fraud, coercion, harassment, or unconscionable or
//                           unlawful means;
//                         </li>
//                         <li>
//                           g. indulge in mis-selling of Products or services to
//                           consumers;
//                         </li>
//                         <li>
//                           h. refuse to take back spurious goods or deficient
//                           services and refund the consideration paid for goods
//                           and services provided;
//                         </li>
//                         <li>
//                           i. charge any entry fee or subscription fee to any
//                           individual;
//                         </li>
//                         <li>
//                           j. induce consumers to make a purchase based upon the
//                           representation that they can reduce or recover the
//                           price by referring prospective customers to the
//                           Consultant for similar purchases;
//                         </li>
//                         <li>
//                           k. promote/participate in a pyramid scheme and/or
//                           money circulation scheme or enroll any person to such
//                           schemes.
//                         </li>
//                         <li>
//                           l. export any of the products outside India, nor sell
//                           to anyone who intends to export the Products outside
//                           India or is suspected to export the Products outside
//                           India without the prior written consent of Tupperware
//                         </li>
//                         <li>
//                           m. sell the Products to anyone who has been
//                           blacklisted by Tupperware or anyone who is suspected
//                           to have been engaged in unlawful sale.
//                         </li>
//                         <li>
//                           n. Sell the products to anyone who intends to further
//                           sell Tupperware products across any channels and not
//                           limited to retail shops, e-commerce sites, Business to
//                           business etc unless having written confirmation from
//                           Tupperware
//                         </li>
//                       </ol>
//                     </li>
//                     <li>
//                       20. This agreement is entered on a personal basis and may
//                       not be assigned or transferred by me to any third party
//                       (including known or unknown) without the written consent
//                       of Tupperware.
//                     </li>
//                     <li>
//                       21. If any provision of these terms & conditions is found
//                       to be invalid or unenforceable, the remaining provisions
//                       shall remain in full force and effect.
//                     </li>
//                     <li>
//                       22. Tupperware reserves its right to modify, alter, amend,
//                       or re-enact the present terms and conditions and all
//                       Tupperware Literature at any time. Any such modification,
//                       alteration or amendment will become effective from the
//                       date of its publication on our website{" "}
//                       <a href="https://www.shoptupperware.in/">
//                         https://www.shoptupperware.in/
//                       </a>{" "}
//                       and my continuation of the Tupperware business shall
//                       constitute as my consent to any changed policies.
//                     </li>
//                     <li>
//                       23. This Agreement shall be governed by and construed in
//                       accordance with the laws of the India, The parties agree
//                       that the proper venue of the adjudication of any dispute
//                       will be in the courts of New Delhi, India. In the event of
//                       any dispute arising under this Agreement (including under
//                       any Services Schedule, the parties shall attempt for a
//                       period of thirty (30) days after receipt by a party of
//                       written request from the other party to resolve the
//                       dispute by amicable settlement. If the parties are unable
//                       to do so within such thirty (30) day period, such dispute
//                       shall be settled by arbitration in accordance with the
//                       Delhi International Arbitration Center, Delhi High Court
//                       ('DIAC') Arbitration Rules in force at the time of the
//                       commencement of the arbitration. There shall be one
//                       arbitrator agreed by the parties within fifteen (15) days
//                       of a party’s written request for arbitration. If the
//                       parties are unable to agree on such arbitrator, an
//                       arbitrator shall be appointed by the DIAC in accordance
//                       with its Arbitration Rules. Any arbitration award may be
//                       enforced in the competent courts of New Delhi, India. Each
//                       party shall bear its own costs in connection with any
//                       arbitration hereunder, however the prevailing party in any
//                       arbitration shall be entitled to reimbursement of its
//                       reasonable arbitration costs, and its reasonable costs
//                       incurred in any enforcement of an arbitration award.
//                       Nothing herein shall prevent a party from seeking
//                       injunctive relief (or any other provisional remedy) from
//                       any court having jurisdiction over the parties and the
//                       subject matter of the dispute as is necessary to protect a
//                       party’s proprietary rights.{" "}
//                     </li>
//                     <li>
//                       24. The liability of Tupperware is limited to the lesser
//                       of a) actual damages or loss accessed by the arbitrator b)
//                       the total commission earned by the Consultant during the
//                       six months period preceding the date of the dispute. No
//                       such limitation of liability is applicable on Tupperware.
//                     </li>
//                     <li>
//                       25. I expressly agree and consent that Tupperware may
//                       collect, record, organize, store, update or modify,
//                       retrieve, consult, use, consolidate, block, erase or
//                       destroy, or otherwise process, through automated means or
//                       manual processing, my personal data, including my
//                       sensitive personal information, set out in this Agreement
//                       and/or otherwise provided by me or processed by Tupperware
//                       in the course of or in connection with my application or
//                       subsequent relationship with Tupperware. I further
//                       expressly agree and consent that Tupperware may share,
//                       disclose, transmit or transfer my personal data, including
//                       my sensitive personal data, to third parties (including
//                       but not limited to Tupperware’s parent
//                     </li>
//                     <li>
//                       26. I have read and understood all the Tupperware
//                       Literature, and understand that Tupperware has the right
//                       to change any of them from time to time and I shall keep
//                       myself updated with the same.
//                     </li>
//                     <li>
//                       27.{" "}
//                       <span className="font-medium">
//                         I hereby confirm that I have read, understood and agreed
//                         to the terms and conditions of this agreement. I will
//                         indicate my consent though clicking “consent” in the
//                         next screen or by signing on the Consultant agreement if
//                         hard copy is provided to me.{" "}
//                       </span>
//                     </li>
//                   </ol>
//                 </div>

//                 <div className="fixed z-10 bottom-0 left-1/2 transform -translate-x-1/2 pr-2 gap-3 md:pr-8 md:gap-7 flex justify-end items-center w-[70vw] h-[10vh] bg-white">
//                   <div>
//                     <button
//                       className="pt-2 pb-2 pr-4 pl-4 border-[1px] border-grey"
//                       onClick={handleAgreeTermsAndConsultant}
//                     >
//                       AGREE
//                     </button>
//                   </div>
//                   <div>
//                     <button
//                       className="pt-2 pb-2 pr-4 pl-4 border-[1px] border-grey"
//                       onClick={handleCloseTermsAndConsultantPopup}
//                     >
//                       DISAGREE
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </>
//           )}
//         </div>
//         {/* Checkbox Section */}
//         {/* <div className=" p-4 mb-6 duration-300">
//                             <div className="flex items-center">
//                                 <input type="checkbox" className="mr-2" />
//                                 <label className="text-gray-600">I agree to the terms and conditions</label>
//                             </div>
//                         </div> */}
//         <div className="p-4 mb-6 duration-300">
//           {/* <div className="flex items-center">
//                         <input
//                             type="checkbox"
//                             className="mr-2"
//                             checked={formData.termsAccepted}
//                             onChange={handleCheckboxChange}
//                         />
//                         <label className="text-gray-600">I agree to <span className="text-blue-500 cursor-pointer" onClick={handleTermsAndConditionsPopup}>Terms and Conditions</span></label>
//                     </div>  */}
//           <div className="flex items-center">
//             <input
//               type="checkbox"
//               className="mr-2"
//               checked={formData.consultantAgreementAccepted}
//               onChange={handleConsultantAgreementCheckboxChange}
//             />
//             <label className="text-gray-600">
//               I agree to{" "}
//               <span
//                 className="text-blue-500 cursor-pointer"
//                 onClick={handleTermsAndConsultantPopup}
//               >
//                 {" "}
//                 Terms of Consultant Agreement Form.
//               </span>
//             </label>
//           </div>
//         </div>

//         {message && (
//           <div>
//             <p className="text-green-500">{message}</p>
//           </div>
//         )}
//         {errorMessage && (
//           <div>
//             <p className="text-red-500">{errorMessage}</p>
//           </div>
//         )}

//         <div className="flex justify-center mt-6 mb-6">
//           {registerUserLoading === true ? (
//             <button
//               className="bg-teal-600 text-white px-8 py-2 rounded flex items-center space-x-2"
//               onClick={handleSubmit}
//               disabled={formData.consultantAgreementAccepted === false}
//             >
//               <span>SUBMITTING...</span>
//               <svg
//                 className="animate-spin h-5 w-5 mr-3 text-white"
//                 xmlns="http://www.w3.org/2000/svg"
//                 fill="none"
//                 viewBox="0 0 24 24"
//               >
//                 <circle
//                   className="opacity-25"
//                   cx="12"
//                   cy="12"
//                   r="10"
//                   stroke="currentColor"
//                   strokeWidth="4"
//                 ></circle>
//                 <path
//                   className="opacity-75"
//                   fill="currentColor"
//                   d="M4 12a8 8 0 018-8v8H4z"
//                 ></path>
//               </svg>
//             </button>
//           ) : (
//             <button
//               className="bg-teal-600 text-white px-8 py-2 rounded flex items-center space-x-2"
//               onClick={handleSubmit}
//               disabled={formData.consultantAgreementAccepted === false}
//             >
//               <span>SUBMIT</span>
//               <span>
//                 <IoMdSend />
//               </span>
//             </button>
//           )}
//         </div>

//         <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
//           <h2 className="text-teal-700 text-lg font-semibold mb-10">
//             Validate Yourself
//           </h2>
//           <div className="relative mb-4 flex justify-between flex-col md:flex-row">
//             <div>
//               <input
//                 type="text"
//                 // value={otp}
//                 name="otp"
//                 // onChange={(e) => setOtp(e.target.value)}
//                 onChange={handleChange}
//                 onFocus={handleOtpFocus}
//                 onBlur={handleOtpBlur}
//                 className="w-full border-b px-4 py-2 focus:outline-none focus:border-teal-500"
//                 disabled={isSubmitted === false}
//               />
//               <label
//                 className={`absolute left-4 transition-all duration-200 ${
//                   isOtpFocused || otp
//                     ? "left-[0px] top-[-30px] text-teal-600 text-sm"
//                     : "top-2 text-gray-500"
//                 }`}
//               >
//                 Enter OTP
//               </label>
//             </div>

//             <div className="flex justify-center mt-4 md:mt-0 flex-col md:flex-row">
//               {otpValidationLoading === true ? (
//                 <button
//                   className="bg-teal-600 text-white px-6 py-2 rounded flex items-center space-x-2"
//                   onClick={otpValidation}
//                 >
//                   <span>VALIDATING...</span>
//                   <svg
//                     className="animate-spin h-5 w-5 mr-3 text-white"
//                     xmlns="http://www.w3.org/2000/svg"
//                     fill="none"
//                     viewBox="0 0 24 24"
//                   >
//                     <circle
//                       className="opacity-25"
//                       cx="12"
//                       cy="12"
//                       r="10"
//                       stroke="currentColor"
//                       strokeWidth="4"
//                     ></circle>
//                     <path
//                       className="opacity-75"
//                       fill="currentColor"
//                       d="M4 12a8 8 0 018-8v8H4z"
//                     ></path>
//                   </svg>
//                 </button>
//               ) : (
//                 <button
//                   className="bg-teal-600 text-white px-6 py-2 rounded flex items-center space-x-2"
//                   onClick={otpValidation}
//                 >
//                   <span>VALIDATE OTP</span>
//                   <span>
//                     <FaCloud />
//                   </span>
//                 </button>
//               )}
//               <button className="bg-teal-600 text-white px-6 py-2 rounded flex items-center space-x-2 mt-4 md:mt-0 md:ml-4">
//                 <span>RESEND OTP</span>
//                 <span>
//                   <FaCloud />
//                 </span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {showOpportunityPopup && (
//           <>
//             <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
//             <div className="fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white w-[70vw] h-[70vh] md:h-[30vh]  text-left ">
//               <div className="max-w-[70vw] max-h-[60vh] md:max-h-[20vh] p-6 md:p-8 break-words overflow-y-auto">
//                 <p>
//                   Tupperware owes its success to entrepreneurial women and will
//                   continue to strive towards helping them achieve their dreams.
//                   Hence this opportunity is only for women candidates for now.
//                   Fulfil your dreams by exploring the opportunity and see how
//                   easy is it to get started.
//                 </p>
//               </div>
//               <div className="fixed z-10 bottom-0 left-1/2 transform -translate-x-1/2 pr-6 md:pr-8 gap-7 flex justify-end items-center w-[70vw] h-[10vh] bg-white">
//                 <div>
//                   <button
//                     className="pt-2 pb-2 pr-4 pl-4 text-white bg-green-500"
//                     onClick={handleCloseOpportunityPopup}
//                   >
//                     OK
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </>
//         )}
//         {showThankyouPopup && (
//           <>
//             <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
//             <div className="fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white w-[55vw] h-[70vh] md:h-[30vh]  text-center ">
//               <div className="max-w-[55vw] max-h-[60vh] md:max-h-[20vh] p-6 md:p-8 break-words overflow-y-auto">
//                 <p>
//                   Thank you for providing your information. Our team will review
//                   it and reach out within 48 to 72 hours for validation. Once
//                   confirmed, you will officially become a Tupperware consultant.
//                   We appreciate your patience!
//                 </p>
//               </div>
//             </div>
//           </>
//         )}
//       </div>
//       {/* ) */}
//       {/* } */}
//       <div className="bg-red-400 p-4 flex justify-around items-center">
//         {/* <img src="/path/to/tupperware-logo.png" alt="Tupperware" className="h-12" /> */}
//         <div>
//           <p className="text-white ">
//             © 2021 Copyright Tupperware India Pvt. Ltd.
//           </p>
//         </div>
//         <div>
//           <p className="text-white">www.tupperwareindia.com</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default RegistrationForm;













import { useEffect, useState } from "react";
import "./registrationform.css";
import { FaCloudUploadAlt } from "react-icons/fa";
import { FaCloud } from "react-icons/fa";
import { IoMdSend } from "react-icons/io";
import axios from "axios";
import { states, cities, pincodes } from "./locationdata.js";

const RegistrationForm = () => {
  // const currentUrl = window.location.href;
  // const location = useLocation()

  // const baseUrl = 'https://tupperware-app.vercel.app/';

  // if (currentUrl !== baseUrl) {
  //     window.location.href = baseUrl;
  // }

  // const [selectedFiles, setSelectedFiles] = useState({
  //     photo: "",
  //     addressProofFront: "",
  //     addressProofBack: "",
  // });

  const [photo, setPhoto] = useState("");
  const [addressProofFront, setAddressProofFront] = useState("");
  const [addressProofBack, setAddressProofBack] = useState("");
  const [photoFileURL, setPhotoFileURL] = useState("");
  // console.log("photoFileURL ============>>>>>>>>>>>", photoFileURL)
  const [addressProofFrontFileURL, setAddressProofFrontFileURL] = useState("");
  const [addressProofBackFileURL, setAddressProofBackFileURL] = useState("");

  const [formData, setFormData] = useState({
    consultantId: "",
    interest: "",
    currentLocationState: "",
    currentLocationCity: "",
    currentLocationPincode: "",
    currentLocationPincodeCode: "",
    currentAddress: "",
    sameAddress: false,
    permanentLocationState: null,
    permanentLocationCity: null,
    permanentLocationPincode: "",
    permanentLocationPincodeCode: "",
    permanentAddress: "",
    name: "",
    dob: "",
    mobile: "",
    email: "",
    addressProof: "",
    documentNumber: "",
    photo: photoFileURL,
    addressProofFront: addressProofFront,
    addressProofBack: addressProofBack,
    termsAccepted: false,
    consultantAgreementAccepted: false,
    otp: null,
  });
  console.log("formData", formData);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      photo: photoFileURL,
      addressProofFront: addressProofFrontFileURL,
      addressProofBack: addressProofBackFileURL,
    }));
  }, [photoFileURL, addressProofFrontFileURL, addressProofBackFileURL]);

  useEffect(() => {
    handleOpportunityPopup();
  }, []);

  // const handleChange = (e) => {
  //     const { name, value, type, checked } = e.target;
  //     setFormData((prevData) => ({
  //         ...prevData,
  //         [name]: type === 'checkbox' ? checked : value,
  //     }));
  //     setErrorMessage("");
  //     setMessage("");
  // };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setFormData((prevData) => {
      if (name === "currentAddress") {
        return {
          ...prevData,
          [name]: value, // Update the current address field
          sameAddress: false, // Automatically uncheck the checkbox
          permanentLocationState: null, // Reset permanent address fields
          permanentLocationCity: null,
          permanentLocationPincode: "",
          permanentAddress: "",
        };
      }

      if (name === "sameAddress") {
        return {
          ...prevData,
          [name]: checked,
          ...(checked && {
            // Copy current address fields if 'sameAddress' is checked
            permanentLocationState: prevData.currentLocationState,
            permanentLocationCity: prevData.currentLocationCity,
            permanentLocationPincode: prevData.currentLocationPincode,
            permanentLocationPincodeCode: prevData.currentLocationPincodeCode,
            permanentAddress: prevData.currentAddress,
          }),
          ...(!checked && {
            // Reset permanent address fields if 'sameAddress' is unchecked
            permanentLocationState: null,
            permanentLocationCity: null,
            permanentLocationPincode: "",
            permanentLocationPincodeCode: "",
            permanentAddress: "",
          }),
        };
      }

      // For other form fields
      return {
        ...prevData,
        [name]: type === "checkbox" ? checked : value,
      };
    });

    setErrorMessage("");
    setMessage("");
  };

  const handleSubmit = () => {
    // console.log('Form Data:', formData);
    setMessage("");
    setErrorMessage("");
    registerUser();
  };

  // const [selectedFiles, setSelectedFiles] = useState({
  //     photo: "",
  //     addressProofFront: "",
  //     addressProofBack: "",
  // });
  //   const [isReferred, setIsReferred] = useState(false);
  const [message, setMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");


  // const handlePhotoFileChange = (event) => {
  //     const { id, files } = event.target;
  //     setSelectedFiles({
  //         ...selectedFiles,
  //         [id]: files[0]?.name || "",
  //     });
  // };
  // const handleAddressProofFrontFileChange = (event) => {
  //     const { id, files } = event.target;
  //     setSelectedFiles({
  //         ...selectedFiles,
  //         [id]: files[0]?.name || "",
  //     });
  // };
  // const handleAddressProofBackFileChange = (event) => {
  //     const { id, files } = event.target;
  //     setSelectedFiles({
  //         ...selectedFiles,
  //         [id]: files[0]?.name || "",
  //     });
  // };

  // const uploadPhoto = async (file) => {
  //     const formData = new FormData();
  //     formData.append('image', file);

  //     try {
  //         const response = await axios.post(
  //             // 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/media/upload/single',
  //             'https://tupperware-service.cloud/services/media/upload/single',
  //             formData,
  //             {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                 },
  //             }
  //         );

  //         if (response.status === 200) {
  //             const uploadedPhotoLocation = response?.data?.Response?.location;
  //             // console.log('File uploaded successfully :::::::::::::::::::::', uploadedPhotoLocation);
  //             setPhotoFileURL(uploadedPhotoLocation);
  //             // formData.photo = uploadedPhotoLocation;
  //         } else {
  //             console.log('Unexpected response status:', response.status);
  //         }
  //     } catch (error) {
  //         console.error('Error uploading file:', error);
  //     }
  // };
  // const uploadAddressProofFront = async (file) => {
  //     const formData = new FormData();
  //     formData.append('image', file);

  //     try {
  //         const response = await axios.post(
  //             // 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/media/upload/single',
  //             'https://tupperware-service.cloud/services/media/upload/single',
  //             formData,
  //             {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                 },
  //             }
  //         );

  //         if (response.status === 200) {
  //             const uploadAddressProofFrontLocation = response?.data?.Response?.location;
  //             // console.log('File uploaded successfully :::::::::::::::::::::', uploadAddressProofFrontLocation);
  //             setAddressProofFrontFileURL(uploadAddressProofFrontLocation);
  //             // formData.photo = uploadedPhotoLocation;
  //         } else {
  //             console.log('Unexpected response status:', response.status);
  //         }
  //     } catch (error) {
  //         console.error('Error uploading file:', error);
  //     }
  // };
  // const uploadAddressProofBack = async (file) => {
  //     const formData = new FormData();
  //     formData.append('image', file);

  //     try {
  //         const response = await axios.post(
  //             // 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/media/upload/single',
  //             'https://tupperware-service.cloud/services/media/upload/single',
  //             formData,
  //             {
  //                 headers: {
  //                     'Content-Type': 'multipart/form-data',
  //                 },
  //             }
  //         );

  //         if (response.status === 200) {
  //             const uploadAddressProofBackLocation = response?.data?.Response?.location;
  //             // console.log('File uploaded successfully :::::::::::::::::::::', uploadAddressProofBackLocation);
  //             setAddressProofBackFileURL(uploadAddressProofBackLocation);
  //             // formData.photo = uploadedPhotoLocation;
  //         } else {
  //             console.log('Unexpected response status:', response.status);
  //         }
  //     } catch (error) {
  //         console.error('Error uploading file:', error);
  //     }
  // };

  // const handlePhotoFileChange = (event) => {
  //     const { files } = event.target;
  //     uploadPhoto(files[0]);
  //     console.log("files[0]",files[0]);
  //     setPhoto(files[0]?.name || "");
  // };

  // const handlePhotoFileChange = async (event) => {
  //     const { files } = event.target;
  //     if (files.length > 0) {
  //         const file = files[0];
  //         await uploadPhoto(file);
  //         setPhoto(file.name);
  //     } else {
  //         setPhoto("");
  //     }
  // };
  const [uploadPhotoLoading, setUploadPhotoLoading] = useState(false);
  const handlePhotoFileChange = async (event) => {
    setErrorMessage("");
    const file = event.target.files[0];

    if (file) {
      //   setPhoto(file.name); // Display file name
      const formData = new FormData();
      formData.append("file", file);
      setUploadPhotoLoading(true);

      try {
        const response = await axios.post(
          "https://tupperware-service.cloud/services/media/uploads",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response?.data?.success === true) {
          // setPhoto(file.name); // Display file name
          setUploadPhotoLoading(false);
          setPhoto(response?.data?.filename); // Display file name
          setPhotoFileURL(response?.data?.filename);
          // console.log("File uploaded successfully:", response.data);
        } else {
          setUploadPhotoLoading(false);
          setErrorMessage(
            "There is something wrong with the file you uploaded, Please try again",
          );
        }
        // Optionally, handle success (e.g., show a success message or update UI)
      } catch (error) {
        console.error("Error uploading file:", error);
        setUploadPhotoLoading(false);
        setErrorMessage(
          "There is something wrong with the file you uploaded, Please try again",
        );
        // Optionally, handle error (e.g., show an error message to the user)
      }
    }
  };

  // const handleAddressProofFrontFileChange = async (event) => {
  //     const { files } = event.target;
  //     if (files.length > 0) {
  //         const file = files[0];
  //         await uploadAddressProofFront(file);
  //         setAddressProofFront(file.name);
  //     } else {
  //         setAddressProofFront("");
  //     }
  // };
  const [
    uploadAddressProofFrontFileLoading,
    setUploadAddressProofFrontFileLoading,
  ] = useState(false);
  const handleAddressProofFrontFileChange = async (event) => {
    setErrorMessage("");
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      setUploadAddressProofFrontFileLoading(true);

      try {
        const response = await axios.post(
          "https://tupperware-service.cloud/services/media/uploads",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );
        if (response?.data?.success === true) {
          // setAddressProofFront(file.name); // Display file name
          setUploadAddressProofFrontFileLoading(false);
          setAddressProofFront(response?.data?.filename); // Display file name
          setAddressProofFrontFileURL(response?.data?.filename);

          // console.log("File uploaded successfully:", response.data);
        } else {
          setUploadAddressProofFrontFileLoading(false);
          setErrorMessage(
            "There is something wrong with the file you uploaded, Please try again",
          );
        }

        // console.log("File uploaded successfully:", response.data);
        // Optionally, handle success (e.g., show a success message or update UI)
      } catch (error) {
        console.error("Error uploading file:", error);
        setUploadAddressProofFrontFileLoading(false);
        setErrorMessage(
          "There is something wrong with the file you uploaded, Please try again",
        );
        // Optionally, handle error (e.g., show an error message to the user)
      }
    }
  };
  // const handleAddressProofBackFileChange = async (event) => {
  //     const { files } = event.target;
  //     if (files.length > 0) {
  //         const file = files[0];
  //         await uploadAddressProofBack(file);
  //         setAddressProofBack(file.name);
  //     } else {
  //         setAddressProofBack("");
  //     }
  // };

  const [
    uploadAddressProofBackFileLoading,
    setUploadAddressProofBackFileLoading,
  ] = useState(false);
  const handleAddressProofBackFileChange = async (event) => {
    setErrorMessage("");
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("file", file);
      setUploadAddressProofBackFileLoading(true);

      try {
        const response = await axios.post(
          "https://tupperware-service.cloud/services/media/uploads",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (response?.data?.success === true) {
          // setAddressProofBack(file.name); // Display file name
          setUploadAddressProofBackFileLoading(false);
          setAddressProofBack(response?.data?.filename); // Display file name
          setAddressProofBackFileURL(response?.data?.filename);
          // console.log("File uploaded successfully:", response.data);
        } else {
          setUploadAddressProofBackFileLoading(false);
          setErrorMessage(
            "There is something wrong with the file you uploaded, Please try again",
          );
        }
      } catch (error) {
        setUploadAddressProofBackFileLoading(false);
        console.error("Error uploading file:", error);
        setErrorMessage(
          "There is something wrong with the file you uploaded, Please try again",
        );
        // Optionally, handle error (e.g., show an error message to the user)
      }
    }
  };

  // console.log("IS CONSENT", isConsent);
  const [showTermsAndConditionsPopup, setShowTermsAndConditionsPopup] =
    useState(false);
  const [showTermsAndConsultantPopup, setShowTermsAndConsultantPopup] =
    useState(false);
  const [showOpportunityPopup, setShowOpportunityPopup] = useState(false);
  const [showThankyouPopup, setShowThankyouPopup] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedCityId, setSelectedCityId] = useState("");

  const [permanentSelectedStateId, setPermanentSelectedStateId] = useState("");
  const [permanentSelectedCityId, setPermanentSelectedCityId] = useState("");
  // const [selectedPincodeId, setSelectedPincodeId] = useState('');
  // console.log("selectedStateId", selectedStateId);
  // console.log("selectedCityId", selectedCityId);
  // console.log("selectedPincodeId",selectedPincodeId);

  const handleStateChange = (e) => {
    const stateId = e.target.value;
    setSelectedStateId(stateId);
    setFormData({
      ...formData,
      sameAddress: false,
      currentLocationState: stateId,
      currentLocationCity: "",
      permanentLocationState: null, // Reset permanent address fields
      permanentLocationCity: null,
      permanentLocationPincode: "",
      permanentAddress: "",
    });
  };

  const handleCityChange = (e) => {
    const cityId = e.target.value;
    setSelectedCityId(cityId);
    setFormData({
      ...formData,
      sameAddress: false,
      currentLocationCity: cityId,
      currentLocationPincode: "",
      permanentLocationState: null, // Reset permanent address fields
      permanentLocationCity: null,
      permanentLocationPincode: "",
      permanentAddress: "",
    });
  };

  // const handlePincodeChange = (e) => {
  //     const pincodeId = e.target.value;
  //     setSelectedPincodeId(pincodeId);
  //     setFormData({ ...formData, currentLocationPincodeId: pincodeId });
  // };

  const handlePincodeChange = (e) => {
    const selectedPincode = e.target.value;
    const selectedPincodeId =
      e.target.options[e.target.selectedIndex].dataset.id; // Pincode ID

    // const selectedPincodeId = e.target.options[e.target.selectedIndex].getAttribute('data-id'); // Pincode ID

    setFormData({
      ...formData,
      sameAddress: false,
      currentLocationPincode: selectedPincode,
      currentLocationPincodeCode: selectedPincodeId,
      permanentLocationState: null, // Reset permanent address fields
      permanentLocationCity: null,
      permanentLocationPincode: "",
      permanentAddress: "",
    });
  };

  const handleConsultantAgreementCheckboxChange = (event) => {
    setFormData({
      ...formData,
      consultantAgreementAccepted: event.target.checked,
    });
  };

  const handlePermanentStateChange = (e) => {
    const stateId = e.target.value;
    setPermanentSelectedStateId(stateId);
    setFormData({
      ...formData,
      permanentLocationState: stateId,
      permanentLocationCity: "",
    });
  };

  const handlePermanentCityChange = (e) => {
    const cityId = e.target.value;
    setPermanentSelectedCityId(cityId);
    setFormData({
      ...formData,
      permanentLocationCity: cityId,
      permanentLocationPincode: "",
    });
  };

  const handlePermanentPincodeChange = (e) => {
    const selectedPincode = e.target.value;
    const selectedPincodeId =
      e.target.options[e.target.selectedIndex].dataset.id; // Pincode ID

    setFormData({
      ...formData,
      permanentLocationPincode: selectedPincode,
      permanentLocationPincodeCode: selectedPincodeId,
    });
  };

  const filteredCities =
    cities &&
    cities.filter((city) => city.stateId === parseInt(selectedStateId));
  const filteredPincodes =
    pincodes &&
    pincodes.filter((pincode) => pincode.cityId === parseInt(selectedCityId));

  const filteredPermanentCities =
    cities &&
    cities.filter(
      (city) =>
        city.stateId ===
        parseInt(permanentSelectedStateId || formData?.permanentLocationState),
    );
  const filteredPermanentPincodes =
    pincodes &&
    pincodes.filter(
      (pincode) =>
        pincode.cityId ===
        parseInt(permanentSelectedCityId || formData?.permanentLocationCity),
    );

  const [isOtpFocused, setIsOtpFocused] = useState(false);

  const dataToSend = {
    userName: formData.name,
    mobileNo: formData.mobile,
    emailId: formData.email,
    // stateId: formData.currentLocationState,
    // cityId: formData.currentLocationCity,
    stateId: formData.currentLocationState,
    cityId: formData.currentLocationCity,
    assemblyId: null,
    joinOrBuy: null,
    status: null,
    closedBy: null,
    closedDate: null,
    landmark: formData.currentAddress,
    esclationStatus: null,
    // consultant Id Jaa rhi h to B, aur agar nhi jaa rhi h to D
    // {formData.consultantId !== "" ? "B" : "D" }
    // userType: "C",
    userType: formData.consultantId !== "" ? "B" : "D",
    esclationToId: null,
    remark: null,
    acceptedDate: null,
    contactedDateTime: null,
    convertedDateTime: null,
    gender: null,
    address1: formData.permanentAddress,
    // pincode: formData.currentLocationPincode,
    pincode: formData.currentLocationPincodeCode,
    // experienceCenterName: null,
    experienceCenterName: "shopify",
    createdBy: null,
    modifiedBy: null,
    otp: formData.otp,
    consultantId: formData.consultantId,
    isConsent: false,
    studioId: null,
    dateOfBirth: formData.dob,
    // photoFileName: formData.photo,
    // photoFileName: photo,
    photoFileName: photoFileURL,
    // photoFileName: "",
    // documentFileName: formData.addressProofFront,
    // documentFileName: addressProofFront,
    documentFileName: addressProofFrontFileURL,
    // documentFileName: "",
    // documentType: formData.addressProof,
    documentType: formData.addressProof,
    documentNo: formData.documentNumber,
    pstateId: formData.permanentLocationState,
    pcityId: formData.permanentLocationCity,
    // ppincode: formData.permanentLocationPincode,
    ppincode: formData.permanentLocationPincodeCode,
    paddress: formData.permanentAddress,
    // documentBackFileName: formData.addressProofBack
    // documentBackFileName: ""
    // documentBackFileName: addressProofBack
    documentBackFileName: addressProofBackFileURL,
  };

  console.log("dataToSend", dataToSend);

  // const registerUser = async (dataToSend) => {
  //     try {
  //         const response = await axios.post('https://tupperware-b78ebe08f4f4.herokuapp.com/services/user/register-user', dataToSend, {
  //             headers: {
  //                 'Content-Type': 'application/json',
  //             },
  //         });
  //         console.log("Response is :=>",response)
  //         return response;
  //     } catch (error) {
  //         console.error('API Error:', error);
  //         throw error;
  //     }
  // };
  const [registerUserLoading, setRegisterUserLoading] = useState(false);
  const registerUser = async () => {
    setRegisterUserLoading(true);

    try {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        // url: 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/user/register-user',
        url: "https://tupperware-service.cloud/services/user/register-user",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(dataToSend),
      };

      axios
        .request(config)
        .then((response) => {
          // console.log("Response is ==========>>>>>>>>>>>", JSON.stringify(response.data));
          // console.log("Second Response is ==========>>>>>>>>>>>", response.data);
          if (response?.data?.success === true) {
            setMessage(response.data.message);
            setIsSubmitted(true);
            setRegisterUserLoading(false);
          } else {
            setErrorMessage(response.data.message);
            setRegisterUserLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setRegisterUserLoading(false);
        });
    } catch (error) {
      setErrorMessage(
        "There is something error in registration, Please try again",
      );
      setRegisterUserLoading(false);
      console.error("API Error:", error);
      throw error;
    }
  };
  const [otpValidationLoading, setOtpValidationLoading] = useState(false);
  const otpValidation = async () => {
    setOtpValidationLoading(true);
    try {
      let config = {
        method: "post",
        maxBodyLength: Infinity,
        // url: 'https://tupperware-b78ebe08f4f4.herokuapp.com/services/user/register-user-verify',
        url: "https://tupperware-service.cloud/services/user/register-user-verify",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify(dataToSend),
      };

      axios
        .request(config)
        .then((response) => {
          // console.log("OTP VALIDATION Response is ==========>>>>>>>>>>>", JSON.stringify(response.data));
          // console.log("OTP VALIDATION Second Response is ==========>>>>>>>>>>>", response.data);
          if (response?.data?.success === true) {
            setMessage(response.data.message);
            setOtpValidationLoading(false);
            setShowThankyouPopup(true);
            setTimeout(() => {
              window.location.href = "https://www.shoptupperware.in/account";
            }, 3000);
          } else {
            setErrorMessage(response.data.message);
            setOtpValidationLoading(false);
          }
        })
        .catch((error) => {
          setErrorMessage(
            "There is something error in registration, Please try again later.",
          );
          console.log(error);
          setOtpValidationLoading(false);
        });
    } catch (error) {
      console.error("API Error:", error);
      setOtpValidationLoading(false);
      setErrorMessage(error);
      throw error;
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setFormData((prevFormData) => ({
        ...prevFormData,
        consultantId: e.target.value,
      }));
      //   if (formData.consultantId === "") {
      //     setIsReferred(false);
      //   } else {
      //     setIsReferred(true);
      //   }

      // setIsReferred(false);
    }
  };

  //   const handleTermsAndConditionsPopup = () => {
  //     setShowTermsAndConditionsPopup(true);
  //   };
  const handleTermsAndConsultantPopup = () => {
    setShowTermsAndConsultantPopup(true);
  };
  const handleCloseTermsAndConditionsPopup = () => {
    formData.termsAccepted = false;
    setShowTermsAndConditionsPopup(false);
  };
  const handleCloseTermsAndConsultantPopup = () => {
    formData.consultantAgreementAccepted = false;
    setShowTermsAndConsultantPopup(false);
  };
  const handleAgreeTermsAndConditions = () => {
    formData.termsAccepted = true;
    setShowTermsAndConditionsPopup(false);
  };
  const handleAgreeTermsAndConsultant = () => {
    formData.consultantAgreementAccepted = true;
    setShowTermsAndConsultantPopup(false);
  };

  const handleOpportunityPopup = () => {
    setShowOpportunityPopup(true);
  };
  const handleCloseOpportunityPopup = () => {
    setShowOpportunityPopup(false);
  };

  const handleOtpFocus = () => {
    setIsOtpFocused(true);
  };

  const handleOtpBlur = () => {
    if (!formData.otp) {
      setIsOtpFocused(false);
    }
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header Section */}
      <div className="bg-red-400 p-4 flex justify-center items-center">
        {/* <img src="/path/to/tupperware-logo.png" alt="Tupperware" className="h-12" /> */}
        <h1 className="text-white text-xl font-bold">
          <a
            href="https://www.shoptupperware.in"
            target="_blank"
            rel="noopener noreferrer"
          >
            Tupperware Consultant Registration
          </a>
        </h1>
      </div>

      {/* Toggle Section */}
      {/* <div className="flex justify-center items-center bg-white p-4 border-b">
                <label className="mr-4 text-gray-600">No one Referred</label>
                <label className="switch">
                    <input type="checkbox" checked={isReferred || formData.consultantId !== ''}
                        onChange={() => setIsReferred(!isReferred)} />
                    <span className="slider round"></span>
                </label>
                <label className="ml-4 text-gray-600">Referred by Someone</label>
            </div> */}

      {/* {isReferred ? ( */}
      {/* <div className="max-w-5xl mx-auto p-6">

                    <div className="border border-teal-700 p-4 shadow-md hover:shadow-lg transition-shadow duration-300">
                        <h2 className="text-teal-700 text-lg font-semibold mb-10">Enter Consultant ID or Mobile No. of Referrer</h2>
                        <div className="relative mb-4">
                            <input
                                type="text"
                                value={consultantId}
                                name="consultantId"
                                onChange={(e) => setConsultantId(e.target.value)}
                                // onChange={handleChange}
                                onFocus={handleConsultantIdFocus}
                                onBlur={handleConsultantIdBlur}
                                onKeyDown={handleKeyDown}
                                className="w-full border rounded px-4 py-2 focus:outline-none focus:border-teal-500"
                            />
                        </div>
                    </div>
                    
                </div> */}

      {/* ) : */}
      {/* ( */}

      <div className="max-w-5xl mx-auto p-6">
        {/* Interest Section */}
        {/* <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
                            <h2 className="text-teal-700 text-lg font-semibold mb-4">Are you interested in</h2>
                            <div className="flex space-x-4">
                                <label className="flex items-center text-gray-600">
                                    <input type="radio" name="interest" value="Social Selling" onChange={handleChange} className="mr-2" /> Social Selling
                                </label>
                                <label className="flex items-center text-gray-600">
                                    <input type="radio" name="interest" value="Direct Selling" onChange={handleChange} className="mr-2" /> Direct Selling
                                </label>
                                <label className="flex items-center text-gray-600">
                                    <input type="radio" name="interest" value="Both" onChange={handleChange} className="mr-2" /> Both
                                </label>
                            </div>
                        </div> */}

        <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
          <h2 className="text-teal-700 text-lg font-semibold mb-5">
            If you are referred by a consultant or Direct Seller
          </h2>
          <div className="relative mb-4">
            <input
              type="text"
              // value={consultantId}
              name="consultantId"
              placeholder="Consultant Id or Mobile No. (Optional)"
              // onChange={(e) => setConsultantId(e.target.value)}
              onChange={handleChange}
              // onChange={handleChange}
              onKeyDown={handleKeyDown}
              className="w-full border rounded px-4 py-2 focus:outline-none focus:border-teal-500"
            />
          </div>
        </div>

        {/* Location Section */}
        <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
          <h2 className="text-teal-700 text-lg font-semibold mb-4">
            Choose your current location
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {/* <div>
                                    <label className="block text-gray-600 mb-1">Select State</label>
                                    <select name="currentLocationState" onChange={handleChange} className="w-full border rounded px-4 py-2">
                                        <option>Select State</option>
                                    </select>
                                </div> */}
            <div>
              <label className="block text-gray-600 mb-1">Select State</label>
              <select
                name="currentLocationState"
                onChange={handleStateChange}
                className="w-full border rounded px-4 py-2"
              >
                <option value="">Select State</option>
                {states &&
                  states.map((state) => (
                    <option key={state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
              </select>
            </div>

            {/* <div>
                                    <label className="block text-gray-600 mb-1">Select City</label>
                                    <select name="currentLocationCity" onChange={handleChange} className="w-full border rounded px-4 py-2">
                                        <option>Select City</option>
                                    </select>
                                </div> */}

            <div>
              <label className="block text-gray-600 mb-1">Select City</label>
              <select
                name="currentLocationCity"
                onChange={handleCityChange}
                value={formData.currentLocationCity}
                className="w-full border rounded px-4 py-2"
                disabled={!selectedStateId}
              >
                <option value="" disabled>
                  Select City
                </option>
                {filteredCities &&
                  filteredCities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
              </select>
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Select Pincode</label>
              <select
                name="currentLocationPincode"
                onChange={handlePincodeChange}
                value={formData.currentLocationPincode}
                className="w-full border rounded px-4 py-2"
                disabled={!selectedCityId}
              >
                <option value="" disabled>
                  Select Pincode
                </option>
                {filteredPincodes ? (
                  filteredPincodes.map((pincode) => (
                    // <option key={pincode.id} value={pincode.id}>
                    <option
                      key={pincode.id}
                      value={pincode.id}
                      data-id={pincode.code}
                    >
                      {pincode.code}
                    </option>
                  ))
                ) : (
                  <option value="" disabled>
                    Select Pincode
                  </option>
                )}
              </select>
            </div>
            <div className="flex items-center">
              <input
                type="checkbox"
                value={formData.sameAddress}
                checked={formData.sameAddress}
                name="sameAddress"
                onChange={handleChange}
                className="mr-2"
              />
              <label className="text-gray-600">
                Tick here if current and permanent address is the same.
                Permanent address should match the details in the address proof
                document uploaded by you.
              </label>
            </div>
            <div className="">
              <label className="block text-gray-600 mb-1">Address</label>
              <input
                type="text"
                name="currentAddress"
                onChange={handleChange}
                className="w-full border rounded px-4 py-2"
                placeholder="Enter Address"
              />
            </div>
          </div>
        </div>
        {/* Permanent Location Section */}
        <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
          <h2 className="text-teal-700 text-lg font-semibold mb-4">
            Choose your permanent location
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-600 mb-1">Select State</label>
              <select
                value={formData?.permanentLocationState || ""}
                name="permanentLocationState"
                onChange={handlePermanentStateChange}
                className="w-full border rounded px-4 py-2"
              >
                <option value="">Select State</option>
                {states &&
                  states.map((state) => (
                    <option key={state.id} value={state.id}>
                      {state.name}
                    </option>
                  ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-600 mb-1">Select City</label>
              <select
                name="permanentLocationCity"
                onChange={handlePermanentCityChange}
                value={formData?.permanentLocationCity || ""}
                // value={cities.find((item) => item.id === formData?.permanentLocationCity)?.code || '' }
                className="w-full border rounded px-4 py-2"
                // disabled={!permanentSelectedStateId}
              >
                <option value="" disabled>
                  Select City
                </option>
                {filteredPermanentCities &&
                  filteredPermanentCities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
              </select>
            </div>

            <div>
              <label className="block text-gray-600 mb-1">Select Pincode</label>
              <select
                name="permanentLocationPincode"
                onChange={handlePermanentPincodeChange}
                value={formData?.permanentLocationPincode || ""}
                // value={pincodes.find((item) => item.id === formData?.permanentLocationPincode)?.code || ''}
                className="w-full border rounded px-4 py-2"
                // disabled={!permanentSelectedCityId}
              >
                <option value="" disabled>
                  Select Pincode
                </option>
                {filteredPermanentPincodes &&
                  filteredPermanentPincodes.map((pincode) => (
                    <option
                      key={pincode.id}
                      value={pincode.id}
                      data-id={pincode.code}
                    >
                      {pincode.code}
                    </option>
                  ))}
              </select>
            </div>
            <div className="">
              <label className="block text-gray-600 mb-1">Address</label>
              <input
                type="text"
                name="permanentAddress"
                value={formData?.permanentAddress}
                onChange={handleChange}
                className="w-full border rounded px-4 py-2"
                placeholder="Enter Address"
              />
            </div>
          </div>
        </div>

        {/* Personal Details Section */}
        <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
          <h2 className="text-teal-700 text-lg font-semibold mb-4">
            Fill in your details
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-600 mb-1">Name</label>
              <input
                type="text"
                name="name"
                onChange={handleChange}
                className="w-full border px-4 py-2"
                placeholder="Enter Name"
              />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Date of Birth</label>
              <input
                type="date"
                name="dob"
                onChange={handleChange}
                className="w-full border rounded px-4 py-2"
              />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Mobile</label>
              <input
                type="text"
                name="mobile"
                onChange={handleChange}
                className="w-full border rounded px-4 py-2"
                placeholder="Enter Mobile Number"
              />
            </div>
            <div>
              <label className="block text-gray-600 mb-1">Email</label>
              <input
                type="email"
                name="email"
                onChange={handleChange}
                className="w-full border rounded px-4 py-2"
                placeholder="Enter Email"
              />
            </div>
          </div>
        </div>

        {/* Upload Photo & Address Proof Section */}
        <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
          <h2 className="text-teal-700 text-lg font-semibold mb-4">
            Upload Photo & Address Proof
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-gray-600 mb-1">
                Select Address Proof
              </label>
              <select
                className="w-full border rounded px-4 py-2"
                name="addressProof"
                // value={formData.addressProof}
                onChange={handleChange}
              >
                <option value="">Select Proof Type</option>
                <option value="A">Aadhaar Card</option>
                <option value="V">Voter Id</option>
                <option value="P">Passport</option>
                <option value="pan">PAN Card</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-600 mb-1">
                Enter Aadhaar/Voter/Passport No.
              </label>
              <input
                type="text"
                name="documentNumber"
                onChange={handleChange}
                className="w-full border rounded px-4 py-2"
                placeholder="Enter Document No."
              />
            </div>
          </div>
          <div className="mt-4">
            {/* Upload Photo */}
            {/* <div className="flex flex-col md:flex-row items-center mb-4">
                                    <div>
                                        <input
                                            type="file"
                                            onChange={handlePhotoFileChange}
                                            id="photo"
                                            className="hidden"
                                        />
                                        <label
                                            htmlFor="photo"
                                            className="bg-teal-600 text-white px-4 py-2 rounded cursor-pointer flex items-center space-x-2"
                                        >
                                            <span><FaCloudUploadAlt /></span>
                                            <span>PHOTOGRAPH (PP SIZE)</span>
                                        </label>
                                    </div>

                                    <div className={`ml-4 h-[30px] border-b ${photo ? "border-teal-600" : "border-gray-400"} flex-grow`}>
                                        <span className="text-gray-700">{photo}</span>
                                    </div>
                                </div> */}

            <div className="flex flex-col md:flex-row items-center mb-4">
              <div>
                <input
                  type="file"
                  onChange={handlePhotoFileChange}
                  id="photo"
                  className="hidden"
                />
                <label
                  htmlFor="photo"
                  className="bg-teal-600 text-white px-4 py-2 rounded cursor-pointer flex items-center space-x-2"
                >
                  {uploadPhotoLoading === true ? (
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  ) : (
                    <FaCloudUploadAlt />
                  )}
                  <span>PHOTOGRAPH (PP SIZE)</span>
                </label>
              </div>

              <div
                className={`ml-4 h-[30px] border-b ${photo ? "border-teal-600" : "border-gray-400"} flex-grow`}
              >
                <span className="text-gray-700">{photo}</span>
              </div>
            </div>

            {/* Upload Address Proof (Front) */}
            <div className="flex flex-col md:flex-row items-center mb-4">
              <div>
                <input
                  type="file"
                  onChange={handleAddressProofFrontFileChange}
                  id="addressProofFront"
                  className="hidden"
                />
                <label
                  htmlFor="addressProofFront"
                  className="bg-teal-600 text-white px-4 py-2 rounded cursor-pointer flex items-center space-x-2"
                >
                  {uploadAddressProofFrontFileLoading === true ? (
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  ) : (
                    <FaCloudUploadAlt />
                  )}

                  <span>ADDRESS PROOF (FRONT)</span>
                </label>
              </div>

              <div
                className={`ml-4 h-[30px] border-b ${addressProofFront ? "border-teal-600" : "border-gray-400"} flex-grow`}
              >
                <span className="text-gray-700">{addressProofFront}</span>
              </div>
            </div>

            {/* Upload Address Proof (Back) */}
            <div className="flex flex-col md:flex-row items-center mb-4">
              <div>
                <input
                  type="file"
                  onChange={handleAddressProofBackFileChange}
                  id="addressProofBack"
                  className="hidden"
                />
                <label
                  htmlFor="addressProofBack"
                  className="bg-teal-600 text-white px-4 py-2 rounded cursor-pointer flex items-center space-x-2"
                >
                  {uploadAddressProofBackFileLoading === true ? (
                    <svg
                      className="animate-spin h-4 w-4 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  ) : (
                    <FaCloudUploadAlt />
                  )}
                  <span>ADDRESS PROOF (BACK)</span>
                </label>
              </div>

              <div
                className={`ml-4 h-[30px] border-b ${addressProofBack ? "border-teal-600" : "border-gray-400"} flex-grow`}
              >
                <span className="text-gray-700">{addressProofBack}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="europe-container mx-auto px-4 py-6 relative">
          {showTermsAndConditionsPopup && (
            <>
              <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
              <div className="fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white w-[70vw] h-[70vh]  text-left ">
                <div className="max-w-[70vw] max-h-[60vh] p-6 md:p-8 break-words overflow-y-auto">
                  <p className="text-xl pb-6">Terms & Conditions</p>
                  <p>
                    WHEREAS in consideration of Tupperware India Private Limited
                    (“Tupperware” and/or “the Company”) appointing me as a
                    Consultant of Tupperware and granting me the right to resell
                    and distribute the products of Tupperware for
                    margin/commission/incentive as per Tupperware’s business
                    plan as explained to me and provided in the Tupperware
                    Literature. I, the Consultant, hereby agree, undertake, and
                    acknowledge that:
                  </p>
                  <ol className="pl-6">
                    <li>
                      1. The following words shall have the meaning as
                      prescribed to them herein:
                      <ol className="pl-6">
                        <li>
                          a. <span className="font-medium">"Distributor”</span>{" "}
                          shall refer to the person authorised by Tupperware to
                          service/train Tupperware Consultants.
                        </li>
                        <li>
                          b. <span className="font-medium">“Product(s)”</span>{" "}
                          shall refer to all products which Tupperware assigns
                          its consultants to sell.
                        </li>
                        <li>
                          c.{" "}
                          <span className="font-medium">
                            “Tupperware Literature”
                          </span>{" "}
                          shall refer to the various documents issued by
                          Tupperware from time to time to govern the Tupperware
                          business, including but not limited to these Terms and
                          Conditions, Tupperware’s business plan, Code of
                          Conduct, Terms as mentioned on Tupperware website,
                          Return and Exchange Policy and Shipment and Payment
                          Policy. Tupperware Literature is shown on the
                          Tupperware’s website{" "}
                          <a href="http://www.tupperwareindia.com">
                            www.tupperwareindia.com
                          </a>
                          .
                        </li>
                      </ol>
                    </li>
                    <li>
                      2. By executing the present agreement, I agree that I have
                      attained the age of majority (18 years) and am legally
                      competent and allowed to enter into this agreement. I
                      undertake to provide government-issued documents for my
                      KYC. I further undertake that I have neither been
                      convicted of a criminal offence nor declared bankrupt
                      during the last five years from the date of execution of
                      the present agreement.
                    </li>
                    <li>
                      3. There are no fees or charges required to join as
                      Tupperware’s Consultant, nor payment of any kind for any
                      sales demonstration or material cost is required. I agree
                      that I am an independent contractor having a
                      principal-to-principal relationship with Tupperware by way
                      of this Agreement. I am neither an employee nor an agent
                      of Tupperware. I am not authorised to bind the Company
                      under any circumstance or legal document; I cannot create
                      any obligation to be performed by the Company. Upon
                      joining, Tupperware may associate me with a Distributor
                      for ease of coordination and supply.
                    </li>
                    <li>
                      4. I understand that any margins and incentives are based
                      on sale of Products as per Tupperware’s business plan and
                      no payment shall be made or requested for the
                      recruitment/enrolment of prospective consultants.
                    </li>
                    <li>
                      5. I understand that I will not be required to purchase
                      any goods or services for an amount or quantity which I
                      cannot reasonably sell or consume.
                    </li>
                    <li>
                      6. I have undertaken orientation session and been provided
                      with fair and accurate information on all aspects of
                      direct selling business including the margins and
                      incentives.
                    </li>
                    <li>
                      7. I shall provide a self-attested copy of my PAN. I
                      understand that if I fail to provide a copy of my PAN
                      card, tax deduction as per the provisions of The Income
                      Tax Act shall apply.
                    </li>
                    <li>
                      8. I understand that Tupperware reserves the right to
                      accept or reject my application as a consultant, with or
                      without assigning any reasons. Submitting the present
                      application shall not give me with any right as a
                      Consultant unless my application is approved by
                      Tupperware.
                    </li>
                    <li>
                      9. Upon joining Tupperware as a Consultant, I shall have
                      the right to withdraw this agreement within 10 working
                      days from the date of joining (“Withdrawal Period”),
                      without penalty and without giving any reasons, by giving
                      Tupperware notice of my intention to do so in writing via
                      e-mail at care@tupperwareindia.com. If I exercise my right
                      to withdraw from this agreement during the Withdrawal
                      Period:
                      <ol className="pl-6">
                        <li>
                          a. I will be required to destroy all records and
                          copies of the Tupperware’s business plan previously
                          provided to me; and
                        </li>
                        <li>
                          b. this agreement will be deemed to have been
                          terminated such that I will be deemed to never have
                          been appointed as a Consultant.this agreement will be
                          deemed to have been terminated such that I will be
                          deemed to never have been appointed as a Consultant.
                        </li>
                      </ol>
                    </li>
                  </ol>
                  <p>
                    If I do not exercise my right to withdraw from this
                    agreement within the Withdrawal Period, I will be deemed to
                    have accepted all terms and conditions contained in this
                    agreement and in the Tupperware Literature.
                  </p>
                  <ol className="pl-6">
                    <li>
                      10. I am only authorised to sell Products as per direct
                      selling model in accordance with the Tupperware Literature
                      and applicable law. However, I am not allowed to sell the
                      Products through any of the following mechanism unless it
                      is pre-approved by Tupperware in writing:
                      <ol className="pl-6">
                        <li>
                          a. internet/online selling (e.g. e-commerce
                          website(s), through any other web site(s), social
                          media, chat room, bulletin board or other similar
                          service(s) to promote or sell the Product(s));
                        </li>
                        <li>
                          b. retail trade including but not limited to shops,
                          supermarkets, stalls, kiosks and exhibitions;
                        </li>
                        <li>c. business to business sales;</li>
                        <li>
                          d. export any of the products outside India, nor sell
                          to anyone who intends to export the Products outside
                          India or is suspected to export the Products outside
                          India without the prior written consent of Tupperware;
                          And
                        </li>
                        <li>
                          e. any other form of sales channels which are not in
                          accordance with Tupperware Literature or applicable
                          law.
                        </li>
                      </ol>
                    </li>
                    <li>
                      11. Attending weekly assembly organized by Tupperware
                      through Distributor is an important aspect of the business
                      as it provides an insight about various Products/ideas and
                      will help me in generating sales and ensuring customer
                      satisfaction, along with obtaining suitable training to
                      carry out my responsibilities under this Agreement.
                    </li>
                    <li>
                      12. I am entitled to terminate this agreement for any
                      reason at any time by submitting a 30-day prior written
                      notice to Tupperware and subject to clearance of all my
                      payment obligations.
                    </li>
                    <li>
                      13. This agreement shall deemed to be terminated if I have
                      not placed any order for purchase of goods for a period as
                      determined by the prevailing Company policy, since the
                      date of this agreement or since the date of the last order
                      for purchase of goods placed by me, whichever is the
                      later. The term of this agreement will otherwise continue
                      to remain in force, unless terminated by either of the
                      Parties as per the Terms and Conditions provided herein
                      and other Tupperware Literature.
                    </li>
                    <li>
                      14. I acknowledge that Tupperware can immediately
                      terminate this agreement if Tupperware has reasonable
                      grounds to believe that:
                      <ol className="pl-6">
                        <li>
                          a. I have provided any wrong information regarding my
                          eligibility as Consultant to Tupperware in this
                          agreement, at the time of joining or thereafter,
                        </li>
                        <li>
                          b. I have misrepresented about Tupperware’s
                          business/Products in any manner,
                        </li>
                        <li>
                          c. I have breached any terms or conditions of this
                          agreement or other Tupperware Literature,
                        </li>
                        <li>
                          d. I have failed to pay my payment obligations to
                          Tupperware in a timely manner,
                        </li>
                        <li>
                          e. if I am found involved in any act of commission or
                          omission which discredits the Company’s brand
                          name/products/literature, or
                        </li>
                        <li>
                          f. if I am found to be in breach of the terms and
                          conditions contained herein, any rules in the
                          Tupperware Literature, any applicable laws including
                          the Direct Selling Guidelines/regulations and/or
                          Consumer Protection (Direct Selling) Rules, 2021 and
                          subsequent amendments, if any.
                        </li>
                        <li>
                          g. If I am found to contravene or breach any of the
                          provisions of these Codes. The termination is
                          effective on the date indicated in the written
                          notification from Tupperware to me. I will have no
                          further claim against Tupperware as a result of the
                          termination.
                        </li>
                        <li>
                          h. If terminated as a Consultant then I am not
                          permitted, either directly or indirectly, to conduct
                          or participate in any business activities related to
                          Tupperware and is not entitled to receive further
                          payment and reward for bonuses, commissions or any
                          other awards whether accruing before or after the
                          termination date.
                        </li>
                        <li>
                          i. Tupperware may at its sole discretion, suspend my
                          account, pending investigation of any alleged breaches
                          to these Codes. During this suspension, no commission
                          or bonuses will be paid. Sales and/or new recruits
                          will not count towards any sales force promotion that
                          may be in place.
                        </li>
                        <li>
                          j. Tupperware reserves the right to claim damages from
                          me if I am found breaching of these Codes and have
                          been involved in activities that may have caused
                          financial losses or otherwise to Tupperware.
                        </li>
                        <li>
                          k. If terminated as a Consultant then I shall not
                          influence existing Consultant and employees of
                          Tupperware in any manner that may disrupt the
                          operations and image of Tupperware.
                        </li>
                        <li>
                          l. If terminated as a Consultant then I will not be
                          accepted again as a Tupperware Consultant.
                        </li>
                      </ol>
                    </li>
                    <li>
                      15. I agree and assume full and independent responsibility
                      for discharge of statutory and regulatory liability in
                      taxes, duties, levies, cess and other governmental fees of
                      any nature as levied from time to time pursuant to the
                      applicable laws of India, in relation to my purchase and
                      sale of goods and services and any situation which arises
                      due to my execution of the present agreement.
                    </li>
                    <li>
                      16. I understand that with respect to the Tupperware’s
                      goods sold by me, I may only extend to end customers such
                      warranty as specified by the Company.
                    </li>
                    <li>
                      17. Except as specifically provided above, Tupperware
                      shall not be liable in any manner to me for any loss or
                      damages of any nature, including consequential damages and
                      loss of earnings arising after my purchase of the
                      Products.
                    </li>
                    <li>
                      18. I shall:
                      <ol className="pl-6">
                        <li>
                          a. at the initiation of any sale representation,
                          truthfully and clearly identify myself, disclose that
                          I am a Consultant of Tupperware, the address of place
                          of business, the nature of goods or services sold and
                          the purpose of such solicitation to the
                          prospect/consumer;
                        </li>
                        <li>
                          b. make an offer to sell to the prospect/consumer by
                          providing accurate and complete information,
                          demonstration of goods and services, prices, credit
                          terms, terms of payment, return, exchange, refund
                          policy, return policy, terms of guarantee and
                          after-sale service;
                        </li>
                        <li>
                          c. I understand that the order form will identify
                          Tupperware as the direct selling entity, me as the
                          Consultant and shall contain the name, address,
                          registration number, identity proof issued by
                          Tupperware and contact number of the Consultant ,
                          complete description of the goods or services to be
                          supplied, the country of origin of the goods, the
                          order date, the total amount to be paid by the
                          consumer, the time and place for inspection of the
                          sample and delivery of goods, consumer's rights to
                          cancel the order or to return the Product in saleable
                          condition and avail full refund on sums paid as per
                          Company’s policy and complete details regarding the
                          complaint redressal mechanism of Tupperware;
                        </li>
                        <li>
                          d. obtain goods and service tax registration,
                          Permanent Account Number registration, all applicable
                          trade registrations and licenses when applicable;
                        </li>
                        <li>
                          e. comply with the requirements of applicable laws,
                          rules and regulations for sale of a product;
                        </li>
                        <li>
                          f. ensure that actual Product delivered to the buyer
                          matches with the description of the Product given and
                          Product ordered; and
                        </li>
                        <li>
                          g. take appropriate steps to ensure the protection of
                          all sensitive personal information provided by the
                          consumer in accordance with the applicable laws for
                          the time being in force and ensure adequate safeguards
                          to prevent access to, or misuse of such data by
                          unauthorized persons.
                        </li>
                      </ol>
                    </li>
                    <li>
                      19. I shall not:
                      <ol className="pl-6">
                        <li>
                          a. visit a consumer's premises without Tupperware’s
                          identity card and prior appointment or the consumer’s
                          consent;
                        </li>
                        <li>
                          b. provide any literature to a prospective customer,
                          which has not been approved by Tupperware;
                        </li>
                        <li>
                          c. use any misleading, deceptive, or unfair trade
                          practices during the sale;
                        </li>
                        <li>
                          d. require a prospective customer to purchase any
                          literature or sales demonstration equipment;
                        </li>
                        <li>
                          e. during a sale, make any claim that is not
                          consistent with claims authorized by Tupperware;
                        </li>
                        <li>
                          f. conduct fraudulent sales activities or false or
                          misleading representations or engage any other form of
                          fraud, coercion, harassment, or unconscionable or
                          unlawful means;
                        </li>
                        <li>
                          g. indulge in mis-selling of Products or services to
                          consumers;
                        </li>
                        <li>
                          h. refuse to take back spurious goods or deficient
                          services and refund the consideration paid for goods
                          and services provided;
                        </li>
                        <li>
                          i. charge any entry fee or subscription fee to any
                          individual;
                        </li>
                        <li>
                          j. induce consumers to make a purchase based upon the
                          representation that they can reduce or recover the
                          price by referring prospective customers to the
                          Consultant for similar purchases;
                        </li>
                        <li>
                          k. promote/participate in a pyramid scheme and/or
                          money circulation scheme or enroll any person to such
                          schemes.
                        </li>
                        <li>
                          l. export any of the products outside India, nor sell
                          to anyone who intends to export the Products outside
                          India or is suspected to export the Products outside
                          India without the prior written consent of Tupperware
                        </li>
                        <li>
                          m. sell the Products to anyone who has been
                          blacklisted by Tupperware or anyone who is suspected
                          to have been engaged in unlawful sale.
                        </li>
                        <li>
                          n. Sell the products to anyone who intends to further
                          sell Tupperware products across any channels and not
                          limited to retail shops, e-commerce sites, Business to
                          business etc unless having written confirmation from
                          Tupperware
                        </li>
                      </ol>
                    </li>
                    <li>
                      20. This agreement is entered on a personal basis and may
                      not be assigned or transferred by me to any third party
                      (including known or unknown) without the written consent
                      of Tupperware.
                    </li>
                    <li>
                      21. If any provision of these terms & conditions is found
                      to be invalid or unenforceable, the remaining provisions
                      shall remain in full force and effect.
                    </li>
                    <li>
                      22. Tupperware reserves its right to modify, alter, amend,
                      or re-enact the present terms and conditions and all
                      Tupperware Literature at any time. Any such modification,
                      alteration or amendment will become effective from the
                      date of its publication on our website{" "}
                      <a href="http://www.tupperwareindia.com">
                        www.tupperwareindia.com
                      </a>{" "}
                      and my continuation of the Tupperware business shall
                      constitute as my consent to any changed policies.
                    </li>
                    <li>
                      23. This Agreement shall be governed by and construed in
                      accordance with the laws of the India, The parties agree
                      that the proper venue of the adjudication of any dispute
                      will be in the courts of New Delhi, India. In the event of
                      any dispute arising under this Agreement (including under
                      any Services Schedule, the parties shall attempt for a
                      period of thirty (30) days after receipt by a party of
                      written request from the other party to resolve the
                      dispute by amicable settlement. If the parties are unable
                      to do so within such thirty (30) day period, such dispute
                      shall be settled by arbitration in accordance with the
                      Delhi International Arbitration Center, Delhi High Court
                      (“DIAC”) Arbitration Rules in force at the time of the
                      commencement of the arbitration. There shall be one
                      arbitrator agreed by the parties within fifteen (15) days
                      of a party’s written request for arbitration. If the
                      parties are unable to agree on such arbitrator, an
                      arbitrator shall be appointed by the DIAC in accordance
                      with its Arbitration Rules. Any arbitration award may be
                      enforced in the competent courts of New Delhi, India. Each
                      party shall bear its own costs in connection with any
                      arbitration hereunder, however the prevailing party in any
                      arbitration shall be entitled to reimbursement of its
                      reasonable arbitration costs, and its reasonable costs
                      incurred in any enforcement of an arbitration award.
                      Nothing herein shall prevent a party from seeking
                      injunctive relief (or any other provisional remedy) from
                      any court having jurisdiction over the parties and the
                      subject matter of the dispute as is necessary to protect a
                      party’s proprietary rights.
                    </li>
                    <li>
                      24. The liability of Tupperware is limited to the lesser
                      of a) actual damages or loss accessed by the arbitrator b)
                      the total commission earned by the Consultant during the
                      six months period preceding the date of the dispute. No
                      such limitation of liability is applicable on Tupperware.
                    </li>
                    <li>
                      25. I expressly agree and consent that Tupperware may
                      collect, record, organize, store, update or modify,
                      retrieve, consult, use, consolidate, block, erase or
                      destroy, or otherwise process, through automated means or
                      manual processing, my personal data, including my
                      sensitive personal information, set out in this Agreement
                      and/or otherwise provided by me or processed by Tupperware
                      in the course of or in connection with my application or
                      subsequent relationship with Tupperware. I further
                      expressly agree and consent that Tupperware may share,
                      disclose, transmit or transfer my personal data, including
                      my sensitive personal data, to third parties (including
                      but not limited to Tupperware’s parent
                    </li>
                    <li>
                      26. I have read and understood all the Tupperware
                      Literature, and understand that Tupperware has the right
                      to change any of them from time to time and I shall keep
                      myself updated with the same.
                    </li>
                    <li>
                      27.{" "}
                      <span className="font-medium">
                        I hereby confirm that I have read, understood and agreed
                        to the terms and conditions of this agreement. I will
                        indicate my consent though clicking “consent” in the
                        next screen or by signing on the Consultant agreement if
                        hard copy is provided to me.
                      </span>
                    </li>
                  </ol>
                </div>

                <div className="fixed z-10 bottom-0 left-1/2 transform -translate-x-1/2 pr-2 gap-3 md:pr-8 md:gap-7 flex justify-end items-center w-[70vw] h-[10vh] bg-white">
                  <div>
                    <button
                      className="pt-2 pb-2 pr-4 pl-4 border-[1px] border-grey"
                      onClick={handleAgreeTermsAndConditions}
                    >
                      AGREE
                    </button>
                  </div>
                  <div>
                    <button
                      className="pt-2 pb-2 pr-4 pl-4 border-[1px] border-grey"
                      onClick={handleCloseTermsAndConditionsPopup}
                    >
                      DISAGREE
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        <div className="europe-container mx-auto px-4 py-6 relative">
          {showTermsAndConsultantPopup && (
            <>
              <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
              <div className="fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white w-[70vw] h-[70vh]  text-left ">
                <div className="max-w-[70vw] max-h-[60vh] p-6 md:p-8 break-words overflow-y-auto">
                  <p className="text-xl pb-6 text-blue">Terms & Conditions</p>
                  <p>
                    WHEREAS in consideration of Tupperware India Private Limited
                    ('Tupperware' and/or 'the Company') appointing me as a
                    Consultant of Tupperware and granting me the right to resell
                    and distribute the products of Tupperware for
                    margin/commission/incentive as per Tupperware’s business
                    plan as explained to me and provided in the Tupperware
                    Literature. I, the Consultant, hereby agree, undertake, and
                    acknowledge that:{" "}
                  </p>
                  <ol className="pl-6">
                    <li>
                      1. The following words shall have the meaning as
                      prescribed to them herein:
                      <ol className="pl-6">
                        <li>
                          a. <span className="font-medium">"Distributor”</span>{" "}
                          shall refer to the person authorised by Tupperware to
                          service/train Tupperware Consultants.{" "}
                        </li>
                        <li>
                          b. <span className="font-medium">“Product(s)”</span>{" "}
                          shall refer to all products which Tupperware assigns
                          its consultants to sell.
                        </li>
                        <li>
                          c.{" "}
                          <span className="font-medium">
                            “Tupperware Literature”
                          </span>{" "}
                          shall refer to the various documents issued by
                          Tupperware from time to time to govern the Tupperware
                          business, including but not limited to these Terms and
                          Conditions, Tupperware’s business plan, Code of
                          Conduct, Terms as mentioned on Tupperware website,
                          Return and Exchange Policy and Shipment and Payment
                          Policy. Tupperware Literature is shown on the
                          Tupperware’s website{" "}
                          <a href="https://www.shoptupperware.in/">
                            https://www.shoptupperware.in/
                          </a>
                          .
                        </li>
                      </ol>
                    </li>
                    <li>
                      2. By executing the present agreement, I agree that I have
                      attained the age of majority (18 years) and am legally
                      competent and allowed to enter into this agreement. I
                      undertake to provide government-issued documents for my
                      KYC. I further undertake that I have neither been
                      convicted of a criminal offence nor declared bankrupt
                      during the last five years from the date of execution of
                      the present agreement.
                    </li>
                    <li>
                      3. There are no fees or charges required to join as
                      Tupperware’s Consultant, nor payment of any kind for any
                      sales demonstration or material cost is required. I agree
                      that I am an independent contractor having a principal-to-
                      principal relationship with Tupperware by way of this
                      Agreement. I am neither an employee nor an agent of
                      Tupperware. I am not authorised to bind the Company under
                      any circumstance or legal document; I cannot create any
                      obligation to be performed by the Company. Upon joining,
                      Tupperware may associate me with a Distributor for ease of
                      coordination and supply.
                    </li>
                    <li>
                      4. I understand that any margins and incentives are based
                      on sale of Products as per Tupperware’s business plan and
                      no payment shall be made or requested for the
                      recruitment/enrolment of prospective consultants.
                    </li>
                    <li>
                      5. I understand that I will not be required to purchase
                      any goods or services for an amount or quantity which I
                      cannot reasonably sell or consume.
                    </li>
                    <li>
                      6. I have undertaken orientation session and been provided
                      with fair and accurate information on all aspects of
                      direct selling business including the margins and
                      incentives.
                    </li>
                    <li>
                      7. I shall provide a self-attested copy of my PAN. I
                      understand that if I fail to provide a copy of my PAN
                      card, tax deduction as per the provisions of The Income
                      Tax Act shall apply.
                    </li>
                    <li>
                      8. I understand that Tupperware reserves the right to
                      accept or reject my application as a consultant, with or
                      without assigning any reasons. Submitting the present
                      application shall not give me with any right as a
                      Consultant unless my application is approved by
                      Tupperware.
                    </li>
                    <li>
                      9. Upon joining Tupperware as a Consultant, I shall have
                      the right to withdraw this agreement within 10 working
                      days from the date of joining ('Withdrawal Period'),
                      without penalty and without giving any reasons, by giving
                      Tupperware notice of my intention to do so in writing via
                      e-mail at care@tupperwareindia.com. If I exercise my right
                      to withdraw from this agreement during the Withdrawal
                      Period:
                      <ol className="pl-6">
                        <li>
                          (i) I will be required to destroy all records and
                          copies of the Tupperware’s business plan previously
                          provided to me; and
                        </li>
                        <li>
                          (ii) this agreement will be deemed to have been
                          terminated such that I will be deemed to never have
                          been appointed as a Consultant.this agreement will be
                          deemed to have been terminated such that I will be
                          deemed to never have been appointed as a Consultant.
                          If I do not exercise my right to withdraw from this
                          agreement within the Withdrawal Period, I will be
                          deemed to have accepted all terms and conditions
                          contained in this agreement and in the Tupperware
                          Literature.{" "}
                        </li>
                      </ol>
                    </li>
                  </ol>
                  {/* <p>If I do not exercise my right to withdraw from this agreement within the Withdrawal Period, I will be deemed to have accepted all terms and conditions contained in this agreement and in the Tupperware Literature.</p> */}
                  <ol className="pl-6">
                    <li>
                      10. I am only authorised to sell Products as per direct
                      selling model in accordance with the Tupperware Literature
                      and applicable law. However, I am not allowed to sell the
                      Products through any of the following mechanism unless it
                      is pre-approved by Tupperware in writing:
                      <ol className="pl-6">
                        <li>
                          a. internet/online selling (e.g. e-commerce
                          website(s), through any other web site(s), social
                          media, chat room, bulletin board or other similar
                          service(s) to promote or sell the Product(s));{" "}
                        </li>
                        <li>
                          b. retail trade including but not limited to shops,
                          supermarkets, stalls, kiosks and exhibitions;{" "}
                        </li>
                        <li>c. business to business sales;</li>
                        <li>
                          d. export any of the products outside India, nor sell
                          to anyone who intends to export the Products outside
                          India or is suspected to export the Products outside
                          India without the prior written consent of Tupperware;
                          And{" "}
                        </li>
                        <li>
                          e. any other form of sales channels which are not in
                          accordance with Tupperware Literature or applicable
                          law.{" "}
                        </li>
                      </ol>
                    </li>
                    <li>
                      11. Attending weekly assembly organized by Tupperware
                      through Distributor is an important aspect of the business
                      as it provides an insight about various Products/ideas and
                      will help me in generating sales and ensuring customer
                      satisfaction, along with obtaining suitable training to
                      carry out my responsibilities under this Agreement.
                    </li>
                    <li>
                      12. I am entitled to terminate this agreement for any
                      reason at any time by submitting a 30-day prior written
                      notice to Tupperware and subject to clearance of all my
                      payment obligations.{" "}
                    </li>
                    <li>
                      13. This agreement shall deemed to be terminated if I have
                      not placed any order for purchase of goods for a period as
                      determined by the prevailing Company policy, since the
                      date of this agreement or since the date of the last order
                      for purchase of goods placed by me, whichever is the
                      later. The term of this agreement will otherwise continue
                      to remain in force, unless terminated by either of the
                      Parties as per the Terms and Conditions provided herein
                      and other Tupperware Literature.{" "}
                    </li>
                    <li>
                      14. I acknowledge that Tupperware can immediately
                      terminate this agreement if Tupperware has reasonable
                      grounds to believe that:
                      <ol className="pl-6">
                        <li>
                          a. I have provided any wrong information regarding my
                          eligibility as Consultant to Tupperware in this
                          agreement, at the time of joining or thereafter,{" "}
                        </li>
                        <li>
                          b. I have misrepresented about Tupperware’s
                          business/Products in any manner,{" "}
                        </li>
                        <li>
                          c. I have breached any terms or conditions of this
                          agreement or other Tupperware Literature,{" "}
                        </li>
                        <li>
                          d. I have failed to pay my payment obligations to
                          Tupperware in a timely manner,
                        </li>
                        <li>
                          e. if I am found involved in any act of commission or
                          omission which discredits the Company’s brand
                          name/products/literature, or{" "}
                        </li>
                        <li>
                          f. if I am found to be in breach of the terms and
                          conditions contained herein, any rules in the
                          Tupperware Literature, any applicable laws including
                          the Direct Selling Guidelines/regulations and/or
                          Consumer Protection (Direct Selling) Rules, 2021 and
                          subsequent amendments, if any.{" "}
                        </li>
                        <li>
                          g. If I am found to contravene or breach any of the
                          provisions of these Codes. The termination is
                          effective on the date indicated in the written
                          notification from Tupperware to me. I will have no
                          further claim against Tupperware as a result of the
                          termination.{" "}
                        </li>
                        <li>
                          h. If terminated as a Consultant then I am not
                          permitted, either directly or indirectly, to conduct
                          or participate in any business activities related to
                          Tupperware and is not entitled to receive further
                          payment and reward for bonuses, commissions or any
                          other awards whether accruing before or after the
                          termination date.{" "}
                        </li>
                        <li>
                          i. Tupperware may at its sole discretion, suspend my
                          account, pending investigation of any alleged breaches
                          to these Codes. During this suspension, no commission
                          or bonuses will be paid. Sales and/or new recruits
                          will not count towards any sales force promotion that
                          may be in place.{" "}
                        </li>
                        <li>
                          j. Tupperware reserves the right to claim damages from
                          me if I am found breaching of these Codes and have
                          been involved in activities that may have caused
                          financial losses or otherwise to Tupperware.{" "}
                        </li>
                        <li>
                          k. If terminated as a Consultant then I shall not
                          influence existing Consultant and employees of
                          Tupperware in any manner that may disrupt the
                          operations and image of Tupperware.{" "}
                        </li>
                        <li>
                          l. If terminated as a Consultant then I will not be
                          accepted again as a Tupperware Consultant.{" "}
                        </li>
                      </ol>
                    </li>
                    <li>
                      15. I agree and assume full and independent responsibility
                      for discharge of statutory and regulatory liability in
                      taxes, duties, levies, cess and other governmental fees of
                      any nature as levied from time to time pursuant to the
                      applicable laws of India, in relation to my purchase and
                      sale of goods and services and any situation which arises
                      due to my execution of the present agreement.{" "}
                    </li>
                    <li>
                      16. I understand that with respect to the Tupperware’s
                      goods sold by me, I may only extend to end customers such
                      warranty as specified by the Company.{" "}
                    </li>
                    <li>
                      17. Except as specifically provided above, Tupperware
                      shall not be liable in any manner to me for any loss or
                      damages of any nature, including consequential damages and
                      loss of earnings arising after my purchase of the
                      Products.{" "}
                    </li>
                    <li>
                      18. I shall:
                      <ol className="pl-6">
                        <li>
                          a. at the initiation of any sale representation,
                          truthfully and clearly identify myself, disclose that
                          I am a Consultant of Tupperware, the address of place
                          of business, the nature of goods or services sold and
                          the purpose of such solicitation to the
                          prospect/consumer;{" "}
                        </li>
                        <li>
                          b. make an offer to sell to the prospect/consumer by
                          providing accurate and complete information,
                          demonstration of goods and services, prices, credit
                          terms, terms of payment, return, exchange, refund
                          policy, return policy, terms of guarantee and
                          after-sale service;{" "}
                        </li>
                        <li>
                          c. provide an order form to the consumer at or prior
                          to the time of the initial sale. I understand that the
                          order form will identify Tupperware as the direct
                          selling entity, me as the Consultant and shall contain
                          the name, address, registration number, identity proof
                          issued by Tupperware and contact number of the
                          Consultant , complete description of the goods or
                          services to be supplied, the country of origin of the
                          goods, the order date, the total amount to be paid by
                          the consumer, the time and place for inspection of the
                          sample and delivery of goods, consumer's rights to
                          cancel the order or to return the Product in saleable
                          condition and avail full refund on sums paid as per
                          Company’s policy and complete details regarding the
                          complaint redressal mechanism of Tupperware;{" "}
                        </li>
                        <li>
                          d. obtain goods and service tax registration,
                          Permanent Account Number registration, all applicable
                          trade registrations and licenses when applicable;{" "}
                        </li>
                        <li>
                          e. comply with the requirements of applicable laws,
                          rules and regulations for sale of a product;
                        </li>
                        <li>
                          f. ensure that actual Product delivered to the buyer
                          matches with the description of the Product given and
                          Product ordered; and{" "}
                        </li>
                        <li>
                          g. take appropriate steps to ensure the protection of
                          all sensitive personal information provided by the
                          consumer in accordance with the applicable laws for
                          the time being in force and ensure adequate safeguards
                          to prevent access to, or misuse of such data by
                          unauthorized persons.{" "}
                        </li>
                      </ol>
                    </li>
                    <li>
                      19. I shall not:
                      <ol className="pl-6">
                        <li>
                          a. visit a consumer's premises without Tupperware’s
                          identity card and prior appointment or the consumer’s
                          consent;
                        </li>
                        <li>
                          b. provide any literature to a prospective customer,
                          which has not been approved by Tupperware;
                        </li>
                        <li>
                          c. use any misleading, deceptive, or unfair trade
                          practices during the sale;
                        </li>
                        <li>
                          d. require a prospective customer to purchase any
                          literature or sales demonstration equipment;
                        </li>
                        <li>
                          e. during a sale, make any claim that is not
                          consistent with claims authorized by Tupperware;
                        </li>
                        <li>
                          f. conduct fraudulent sales activities or false or
                          misleading representations or engage any other form of
                          fraud, coercion, harassment, or unconscionable or
                          unlawful means;
                        </li>
                        <li>
                          g. indulge in mis-selling of Products or services to
                          consumers;
                        </li>
                        <li>
                          h. refuse to take back spurious goods or deficient
                          services and refund the consideration paid for goods
                          and services provided;
                        </li>
                        <li>
                          i. charge any entry fee or subscription fee to any
                          individual;
                        </li>
                        <li>
                          j. induce consumers to make a purchase based upon the
                          representation that they can reduce or recover the
                          price by referring prospective customers to the
                          Consultant for similar purchases;
                        </li>
                        <li>
                          k. promote/participate in a pyramid scheme and/or
                          money circulation scheme or enroll any person to such
                          schemes.
                        </li>
                        <li>
                          l. export any of the products outside India, nor sell
                          to anyone who intends to export the Products outside
                          India or is suspected to export the Products outside
                          India without the prior written consent of Tupperware
                        </li>
                        <li>
                          m. sell the Products to anyone who has been
                          blacklisted by Tupperware or anyone who is suspected
                          to have been engaged in unlawful sale.
                        </li>
                        <li>
                          n. Sell the products to anyone who intends to further
                          sell Tupperware products across any channels and not
                          limited to retail shops, e-commerce sites, Business to
                          business etc unless having written confirmation from
                          Tupperware
                        </li>
                      </ol>
                    </li>
                    <li>
                      20. This agreement is entered on a personal basis and may
                      not be assigned or transferred by me to any third party
                      (including known or unknown) without the written consent
                      of Tupperware.
                    </li>
                    <li>
                      21. If any provision of these terms & conditions is found
                      to be invalid or unenforceable, the remaining provisions
                      shall remain in full force and effect.
                    </li>
                    <li>
                      22. Tupperware reserves its right to modify, alter, amend,
                      or re-enact the present terms and conditions and all
                      Tupperware Literature at any time. Any such modification,
                      alteration or amendment will become effective from the
                      date of its publication on our website{" "}
                      <a href="https://www.shoptupperware.in/">
                        https://www.shoptupperware.in/
                      </a>{" "}
                      and my continuation of the Tupperware business shall
                      constitute as my consent to any changed policies.
                    </li>
                    <li>
                      23. This Agreement shall be governed by and construed in
                      accordance with the laws of the India, The parties agree
                      that the proper venue of the adjudication of any dispute
                      will be in the courts of New Delhi, India. In the event of
                      any dispute arising under this Agreement (including under
                      any Services Schedule, the parties shall attempt for a
                      period of thirty (30) days after receipt by a party of
                      written request from the other party to resolve the
                      dispute by amicable settlement. If the parties are unable
                      to do so within such thirty (30) day period, such dispute
                      shall be settled by arbitration in accordance with the
                      Delhi International Arbitration Center, Delhi High Court
                      ('DIAC') Arbitration Rules in force at the time of the
                      commencement of the arbitration. There shall be one
                      arbitrator agreed by the parties within fifteen (15) days
                      of a party’s written request for arbitration. If the
                      parties are unable to agree on such arbitrator, an
                      arbitrator shall be appointed by the DIAC in accordance
                      with its Arbitration Rules. Any arbitration award may be
                      enforced in the competent courts of New Delhi, India. Each
                      party shall bear its own costs in connection with any
                      arbitration hereunder, however the prevailing party in any
                      arbitration shall be entitled to reimbursement of its
                      reasonable arbitration costs, and its reasonable costs
                      incurred in any enforcement of an arbitration award.
                      Nothing herein shall prevent a party from seeking
                      injunctive relief (or any other provisional remedy) from
                      any court having jurisdiction over the parties and the
                      subject matter of the dispute as is necessary to protect a
                      party’s proprietary rights.{" "}
                    </li>
                    <li>
                      24. The liability of Tupperware is limited to the lesser
                      of a) actual damages or loss accessed by the arbitrator b)
                      the total commission earned by the Consultant during the
                      six months period preceding the date of the dispute. No
                      such limitation of liability is applicable on Tupperware.
                    </li>
                    <li>
                      25. I expressly agree and consent that Tupperware may
                      collect, record, organize, store, update or modify,
                      retrieve, consult, use, consolidate, block, erase or
                      destroy, or otherwise process, through automated means or
                      manual processing, my personal data, including my
                      sensitive personal information, set out in this Agreement
                      and/or otherwise provided by me or processed by Tupperware
                      in the course of or in connection with my application or
                      subsequent relationship with Tupperware. I further
                      expressly agree and consent that Tupperware may share,
                      disclose, transmit or transfer my personal data, including
                      my sensitive personal data, to third parties (including
                      but not limited to Tupperware’s parent
                    </li>
                    <li>
                      26. I have read and understood all the Tupperware
                      Literature, and understand that Tupperware has the right
                      to change any of them from time to time and I shall keep
                      myself updated with the same.
                    </li>
                    <li>
                      27.{" "}
                      <span className="font-medium">
                        I hereby confirm that I have read, understood and agreed
                        to the terms and conditions of this agreement. I will
                        indicate my consent though clicking “consent” in the
                        next screen or by signing on the Consultant agreement if
                        hard copy is provided to me.{" "}
                      </span>
                    </li>
                  </ol>
                </div>

                <div className="fixed z-10 bottom-0 left-1/2 transform -translate-x-1/2 pr-2 gap-3 md:pr-8 md:gap-7 flex justify-end items-center w-[70vw] h-[10vh] bg-white">
                  <div>
                    <button
                      className="pt-2 pb-2 pr-4 pl-4 border-[1px] border-grey"
                      onClick={handleAgreeTermsAndConsultant}
                    >
                      AGREE
                    </button>
                  </div>
                  <div>
                    <button
                      className="pt-2 pb-2 pr-4 pl-4 border-[1px] border-grey"
                      onClick={handleCloseTermsAndConsultantPopup}
                    >
                      DISAGREE
                    </button>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
        {/* Checkbox Section */}
        {/* <div className=" p-4 mb-6 duration-300">
                            <div className="flex items-center">
                                <input type="checkbox" className="mr-2" />
                                <label className="text-gray-600">I agree to the terms and conditions</label>
                            </div>
                        </div> */}
        <div className="p-4 mb-6 duration-300">
          {/* <div className="flex items-center">
                        <input
                            type="checkbox"
                            className="mr-2"
                            checked={formData.termsAccepted}
                            onChange={handleCheckboxChange}
                        />
                        <label className="text-gray-600">I agree to <span className="text-blue-500 cursor-pointer" onClick={handleTermsAndConditionsPopup}>Terms and Conditions</span></label>
                    </div>  */}
          <div className="flex items-center">
            <input
              type="checkbox"
              className="mr-2"
              checked={formData.consultantAgreementAccepted}
              onChange={handleConsultantAgreementCheckboxChange}
            />
            <label className="text-gray-600">
              I agree to{" "}
              <span
                className="text-blue-500 cursor-pointer"
                onClick={handleTermsAndConsultantPopup}
              >
                {" "}
                Terms of Consultant Agreement Form.
              </span>
            </label>
          </div>
        </div>

        {message && (
          <div>
            <p className="text-green-500">{message}</p>
          </div>
        )}
        {errorMessage && (
          <div>
            <p className="text-red-500">{errorMessage}</p>
          </div>
        )}

        <div className="flex justify-center mt-6 mb-6">
          {registerUserLoading === true ? (
            <button
              className="bg-teal-600 text-white px-8 py-2 rounded flex items-center space-x-2"
              onClick={handleSubmit}
              disabled={formData.consultantAgreementAccepted === false}
            >
              <span>SUBMITTING...</span>
              <svg
                className="animate-spin h-5 w-5 mr-3 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8v8H4z"
                ></path>
              </svg>
            </button>
          ) : (
            <button
              className="bg-teal-600 text-white px-8 py-2 rounded flex items-center space-x-2"
              onClick={handleSubmit}
              disabled={formData.consultantAgreementAccepted === false}
            >
              <span>SUBMIT</span>
              <span>
                <IoMdSend />
              </span>
            </button>
          )}
        </div>

        <div className="border border-teal-700 p-4 mb-6 shadow-md hover:shadow-lg transition-shadow duration-300">
          <h2 className="text-teal-700 text-lg font-semibold mb-10">
            Validate Yourself
          </h2>
          <div className="relative mb-4 flex justify-between flex-col md:flex-row">
            <div>
              <input
                type="text"
                // value={otp}
                name="otp"
                // onChange={(e) => setOtp(e.target.value)}
                onChange={handleChange}
                onFocus={handleOtpFocus}
                onBlur={handleOtpBlur}
                className="w-full border-b px-4 py-2 focus:outline-none focus:border-teal-500"
                disabled={isSubmitted === false}
              />
              <label
                className={`absolute left-4 transition-all duration-200 ${
                  isOtpFocused
                    ? "left-[0px] top-[-30px] text-teal-600 text-sm"
                    : "top-2 text-gray-500"
                }`}
              >
                Enter OTP
              </label>
            </div>

            <div className="flex justify-center mt-4 md:mt-0 flex-col md:flex-row">
              {otpValidationLoading === true ? (
                <button
                  className="bg-teal-600 text-white px-6 py-2 rounded flex items-center space-x-2"
                  onClick={otpValidation}
                >
                  <span>VALIDATING...</span>
                  <svg
                    className="animate-spin h-5 w-5 mr-3 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8H4z"
                    ></path>
                  </svg>
                </button>
              ) : (
                <button
                  className="bg-teal-600 text-white px-6 py-2 rounded flex items-center space-x-2"
                  onClick={otpValidation}
                >
                  <span>VALIDATE OTP</span>
                  <span>
                    <FaCloud />
                  </span>
                </button>
              )}
              <button className="bg-teal-600 text-white px-6 py-2 rounded flex items-center space-x-2 mt-4 md:mt-0 md:ml-4">
                <span>RESEND OTP</span>
                <span>
                  <FaCloud />
                </span>
              </button>
            </div>
          </div>
        </div>

        {showOpportunityPopup && (
          <>
            <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
            <div className="fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white w-[70vw] h-[70vh] md:h-[30vh]  text-left ">
              <div className="max-w-[70vw] max-h-[60vh] md:max-h-[20vh] p-6 md:p-8 break-words overflow-y-auto">
                <p>
                  Tupperware owes its success to entrepreneurial women and will
                  continue to strive towards helping them achieve their dreams.
                  Hence this opportunity is only for women candidates for now.
                  Fulfil your dreams by exploring the opportunity and see how
                  easy is it to get started.
                </p>
              </div>
              <div className="fixed z-10 bottom-0 left-1/2 transform -translate-x-1/2 pr-6 md:pr-8 gap-7 flex justify-end items-center w-[70vw] h-[10vh] bg-white">
                <div>
                  <button
                    className="pt-2 pb-2 pr-4 pl-4 text-white bg-green-500"
                    onClick={handleCloseOpportunityPopup}
                  >
                    OK
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        {showThankyouPopup && (
          <>
            <div className="fixed top-0 left-0 w-full h-full opacity-30 bg-black"></div>
            <div className="fixed z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white w-[55vw] h-[70vh] md:h-[30vh]  text-center ">
              <div className="max-w-[55vw] max-h-[60vh] md:max-h-[20vh] p-6 md:p-8 break-words overflow-y-auto">
                <p>
                  Thank you for providing your information. Our team will review
                  it and reach out within 48 to 72 hours for validation. Once
                  confirmed, you will officially become a Tupperware consultant.
                  We appreciate your patience!
                </p>
              </div>
            </div>
          </>
        )}
      </div>
      {/* ) */}
      {/* } */}
      <div className="bg-red-400 p-4 flex justify-around items-center">
        {/* <img src="/path/to/tupperware-logo.png" alt="Tupperware" className="h-12" /> */}
        <div>
          <p className="text-white ">
            © 2021 Copyright Tupperware India Pvt. Ltd.
          </p>
        </div>
        <div>
          <p className="text-white">www.tupperwareindia.com</p>
        </div>
      </div>
    </div>
  );
};

export default RegistrationForm;
